import React, { Component } from 'react'; //different
import {
    BrowserRouter,
    Routes,
    Route
} from "react-router-dom";
import './App.css';
import Footer from './footer';
import jwt_decode from "jwt-decode";
import Swal from 'sweetalert2'
import instance from "./axios-instance";
import { NumericFormat } from 'react-number-format';
import Systems from "./SystemFunction";
import Casino from "./casino";
import Slot from "./slot";
import Fishing from "./fising";
import Sport from "./sport";
// import TextSlider from "./textslide";
import Afficiate from "./affiliate";
import Signin from "./signin";
import Register from "./register";
import Loss from "./loss";
import Promotion from "./promotionx";
import { isMobile } from 'react-device-detect';
import Profile from "./profile";
import Statement from "./statement";
import Luckyfortune from "./luckyfortune";
import Login from './login';
import Checkindaily from "./checkin"; //import
import Center from "./centermenu";
import Listmenu from "./banner";
import NavMenu from "./navmenu";


import Banner from "./banner";
// import MoblieMenu from "./mobilemenu";
import Mainindex from "./mainindex";
import Lowmenu from "./lowmenu";
// import Lotto from "./lotto";
import Listgameall from "./linklistall";
// import GameHit from "./gamehit";
import moment from 'moment';
import md5 from 'md5';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { LoopTwoTone } from '@mui/icons-material';
import { ToastContainer, toast } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
var settings = {
    dots: true,
    infinite: true,
    slidesToShow: (window.innerWidth <= 760) ? 1 : 1,
    slidesToScroll: 1,
    autoplay: true,
    speed: 2000,
    autoplaySpeed: 3000,
    cssEase: "linear"
};
class Main extends Component {
    constructor(props) {
        super(props)
        this.state = {
            categorylist: [],
            listitallgame: [],
            providorlist: [],
            currentTime: new Date().getTime(),
            slotlist: [],
            searchKeyword: "",
            filteredList: null, // เก็บรายการหลังค้นหา
            sportlist: [],
            tabselectprovidor: "",
            fishinglist: [],
            userrecomend: "",
            gamecardlist: [],
            virtuallist: [],
            trueaccount: true,
            limit: [],
            tabselectdeposit: 0,
            rewardlist: [],
            lottolist: [],
            recentlist: [],
            activePage: 1,
            stateopterror: "",
            ThmeseV: null,
            pagecount: 1,
            products_page_count: 1,
            isActive: false,
            activeTab: 1,
            resetpass: 0,
            logoimg: '',
            describemain: "",
            paymentlist: null,
            checkcredit: false,
            refer: 1,
            showmodal: false,
            historylist: [],
            formData: {}, // Contains login form data
            errors: {}, // Contains login field errors
            formSubmitted: false, // Indicates submit status of login form
            tblprofile: [],
            userid: null,
            afficiate: [],
            modalx: false,
            cashoutSet: [],
            modal: false,
            linkaff: "",
            point: 0,
            depositamount: 0,
            maxwithdrawstatus: 0,
            useradvice: [],
            afficiatetoday: [],
            afficiateall: [],
            balance: 0,
            counter: 300,
            qrcode: null,
            qrcodecheck: false,
            firstname: null,
            lastname: null,
            activeTab: 1,
            alert: null,
            modalOpen: false,
            handleClose: false,
            proderedeemlist: [],
            token: window.localStorage.getItem("token"),
            type: "",
            prolistx: [],
            prodetail: [],
            username: "",
            tabselect: 11,
            showpassnew: false,
            showpasscf: false,
            showpassold: false,
            amount: "",
            remark: "",
            mainacc: "",
            rankpic: "1.jpeg",
            rankname: null,
            rankob: null,
            rankpoint: 0,
            limit: null,
            name: "",
            password: "",
            oldpassword: "",
            passwordcf: "",
            left: false,
            pathname: "",
            linelink: "",
            mainsetting: [],
            rewardlist: [],
            activePage: 1,
            checkboxcookie: false,
            isActive: false,
            formData: {}, // Contains login form data
            errors: {}, // Contains login field errors
            formSubmitted: false, // Indicates submit status of login form
            loading: false, // Indicates in progress state of login form
            pagecount: 1,
            username: null,
            settingwheel: "",
            settingcheckin: "",
            userid: null,
            phoneNumber: "",
            balance: 0,
            mainacc: null,
            paymentgateway: null,
            tabselectsec: 0,
            qrcode: null,
            stateregis: 1,
            checkboxacc: 0,
            products_page_count: 1,
            loginstate: false,
            fullname: null,
            lname: null,
            link: "",
            alert: null,
            depositstate: 0,
            stateforget: 1,
            depositamount: 0,
            stateopterror: "",
            btnisActive: true,
            otpphone: "",
            token: window.localStorage.getItem("token"),
            accnumber: null,
            accnumbertxt: null,
            withdrawamount: 0,
            rankpoint: 0,
            changepassword: false,
            linelink: "",
            errortext: "",
            datas: null,
            otpphoneforget: "",
            affpercent: 0,
            counter: 300,
            userrecomend: "",
            historylist: [],
            useradvice: [],
            cashoutlist: [],
            tblnextrank: [],
            tblrankall: [],
            maxwithdrawstatus: 0,
            tblprofile: [],
            prodetail: [],
            oldpassword: "",
            linkaff: "",
            webnamex: "",
            inviteSet: "",
            truegiftlink: "",
            proderedeem: [],
            qrcode: null,
            proderedeemlist: [],
            buttoncliam: false,
            limit: null,
            rankpic: "1.jpeg",
            rankname: null,
            rankob: null,
            cashoutSet: [],
            tblPopupMenu1: [],
            tblPopupMenu2: [],
            tblPopupMenu: null,
            termAndCondition: false,
            errorstatus: false,
        }
    }
    copyCode = (text) => {
        navigator.clipboard
            .writeText(text)
            .then(() => {
                this.notify("warning", 'CopyCode!!!');
            })
            .catch((err) => {
                // console.log(err.message);
            });

    };
    async modalerror(object) {
        // await Swal.fire({
        //     title: object.title + "!",
        //     text: object.text,
        //     icon: object.title,
        //     confirmButtonText: 'ตกลง'
        // })
        await this.notify(object.title, object.text);
    }
    validatergisterForm = async (e, fname) => {
        e.preventDefault();
        const { phoneNumber, password, passwordcf, bankselect, checkboxacc, accnumbertxt } = this.state;
        console.log(bankselect);
        console.log(this.state)
        if (accnumbertxt === "" || typeof accnumbertxt == "undefined") {
            var title = 'error'
            var text = 'คุณไม่ทำการใส่เลขบัญชีธนาคาร'
            var object = { title, text }
            this.modalerror(object);

        }
        else if (fname === "") {

            var title = 'error'
            var text = 'คุณไม่ทำการใส่ ชื่อ-นามสกุล'
            var object = { title, text }
            this.modalerror(object);

        }
        else if (password.length > 15) {
            var title = 'error'
            var text = 'พาสเวิดสูงสุดไม่เกิน 15 ตัว'
            var object = { title, text }
            this.modalerror(object);
        }
        else if (password.length < 6) {
            var title = 'error'
            var text = 'พาสเวิดต่ำไม่เกิน 15 ตัว'
            var object = { title, text }
            this.modalerror(object);
        }
        else if (password != passwordcf) {
            var title = 'error'
            var text = 'รหัสยิืนยันไม่ตรงกัน'
            var object = { title, text }
            this.modalerror(object);
        }
        else {
            await instance.post("/api/v1/register", {
                User_id: phoneNumber,
                name: fname,
                password: password,
                accbank: checkboxacc,
                accno: accnumbertxt,
                System: Systems,
                Useradvise: this.state.userrecomend
            }).then(async (res) => {
                console.log(res.data);
                if (res.data.status === 200) {
                    var title = 'success'
                    var text = 'สมัครสำเร็จกำลังเปลี่ยนเส้นทาง'
                    var object = { title, text }
                    await this.modalerror(object);

                    await instance.post("/api/v1/userlogin", {
                        userid: phoneNumber,
                        password: password,
                        System: Systems,
                        Function: 'validateLoginForm-navbar.js'
                    }).then((res) => {
                        if (res.data.status === 200) {
                            localStorage.setItem('auth_token', res.data.token);
                            setInterval(() =>
                                window.location.href = '/'
                                , 2000);

                        }
                    });
                }
                else if (res.data.status === 203) {
                    var title = 'error'
                    var text = 'เลขบัญชี นี้ทำการสมัครไปแล้ว'
                    var object = { title, text }
                    this.modalerror(object);
                }
                else if (res.data.status === 202) {
                    var title = 'error'
                    var text = 'Username นี้ทำการสมัครไปแล้ว'
                    var object = { title, text }
                    this.modalerror(object);
                }
                else {
                    var title = 'error'
                    var text = 'Username หรือ ชื่อในการสมัครไม่ถูกต้อง'
                    var object = { title, text }
                    this.modalerror(object);
                }
            });
        }


    };
    promotionlist = () => {
        instance.post("/api/v1/getpromotion", {
            System: Systems,
        }).then(async (res) => {
            if (res.data.status === 200) {
                this.setState({
                    prolistx: res.data.message,
                });
            }
        }).catch(async (err) => {
            //   console.log(err);

            if (err.response.status === 401 || err.response.status === 403) {
                localStorage.clear();
                await this.notify("warning", 'Session ของท่านหมดอายุ กรุณา login เข้าสู่ระบบอีกครั้ง');
                window.location.href = '/';
            }
        });
    }
    handleClickdeposit = async (e, price) => {
        this.setState({
            depositamount: price

        });
    }
    checklogin() {
        var token = localStorage.getItem('auth_token');
        console.log(11111111, token);
        if (token != null) {
            var decoded = jwt_decode(token);
            var Username = decoded.message.playerid;
            this.rechecklogin(Username, token);
        }
        else {
            this.setState({
                loginstate: false,
            });
        }
    }
    addDefaultSrc(ev, listitem) {
        const origin = listitem.split("http");
        if (origin.length > 1) {
            const origin = listitem.split("https");
            if (origin.length > 1) return listitem;
            else return listitem.replace("http", "https");
        }
        else {
            return "https://ardmhzelxcmj.ocrazeckyunc.com" + listitem

        }

    }
    onChangexdep = event => {
        ////console.log(event.target.value);
        if (event.target !== undefined) {

            this.setState({ depositamount: event.target.value });
        }
    };
    async recheccredit(evt) {
        try {
            const btn = evt.currentTarget; // เก็บอ้างอิงไว้ก่อน

            btn.classList.add("fa-spin");

            const token = localStorage.getItem('auth_token');
            if (!token) throw new Error("No token found");

            const decoded = jwt_decode(token);
            const Username = decoded.message.playerid;

            this.setState({
                checkcredit: true,
                userid: Username,
                username: Username,
                firstname: decoded.message.firstname,
                lastname: decoded.message.lastname,
                loginstate: true,
            });

            const res = await instance.post(
                "/api/v1/checkpoint",
                {
                    userid: Username,
                    System: Systems,
                    Function: "recheccredit-App.js",
                },
                {
                    headers: { Authorization: `Bearer ${token}` },
                }
            );

            if (res.data.status === 200) {
                localStorage.setItem("auth_token", res.data.token);
                this.setState(
                    {
                        accnumber: res.data.message.accnumber,
                        userid: res.data.message.member_id,
                        username: res.data.message.playerid,
                        fullname: res.data.message.firstname,
                        point: res.data.message.Point,
                        balance: res.data.databalance,
                        loginstate: true,
                        checkcredit: false,
                    },
                    () => {
                        btn.classList.remove("fa-spin");
                        console.log(this.state.checkcredit, "recheckcredit");
                    }
                );
            } else if (res.data.status === 401) {
                localStorage.clear();
                await this.notify("warning", "Session ของท่านหมดอายุ กรุณา login เข้าสู่ระบบอีกครั้ง");
                window.location.href = "/";
            } else {
                console.warn("Response:", res.data);
                this.setState({ checkcredit: false });
            }
        } catch (err) {
            if (err.response?.status === 401 || err.response?.status === 403) {
                localStorage.clear();
                await this.notify("warning", "Session ของท่านหมดอายุ กรุณา login เข้าสู่ระบบอีกครั้ง");
                window.location.href = "/";
            } else {
                console.error("Unexpected error:", err);
                this.setState({ checkcredit: false });
            }
        }
    }


    redeemlotto = (e, _id, roomid) => {
        const userAgent = navigator.userAgent;
        this.checklogin();

        if (!this.state.loginstate) {
            this.notify("error", 'คุณยังไม่ได้เข้าสู่ระบบ');
            return;
        }

        if (this.state.username) {
            instance.post("/api/v1/tablauncherlotto", {
                roomid: roomid,
                playerUsername: this.state.username,
                isMobile: isMobile,
                System: Systems,
                demo: false,
            }).then((res) => {
                if (res.data.status === 200) {
                    const launcher = res.data.message.launcher;
                    if (launcher) {
                        if (/iPad|iPhone|Macintosh|iPod/.test(userAgent) && !window.MSStream) {
                            window.location.href = launcher.mobile;
                        } else {
                            isMobile
                                ? window.open(launcher.mobile)
                                : window.open(launcher.desktop, '_blank', 'height=1000,width=1000');
                        }
                    } else {
                        Swal.fire({
                            title: 'error!',
                            text: 'ขณะนี้เกมมีปัญหากรุณารอซักครู่',
                            icon: 'error',
                            confirmButtonText: 'ตกลง',
                        });
                    }
                }
            });
        }
    };
    calculateCountdown = (drawTime, format) => {
        const now = new Date().getTime();
        const drawTimeInMs = new Date(drawTime).getTime();
        const timeLeft = drawTimeInMs - now;

        if (timeLeft <= 0) {
            return "หมดเวลา";
        }

        const days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
        const hours = Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);

        const formattedDays = days > 0 ? `${days} วัน ` : "";
        const formattedHours = `${hours < 10 ? `0${hours}` : hours}`;

        // เงื่อนไข: ถ้ามากกว่า 1 วัน ให้แสดงแค่วันและชั่วโมง
        if (days > 1) {
            return `${formattedDays}${formattedHours} ชั่วโมง`;
        }

        // ถ้าน้อยกว่าหรือเท่ากับ 1 วัน ให้แสดงเวลาเต็ม
        if (format === "short") {
            return `${formattedHours}:${minutes < 10 ? `0${minutes}` : minutes}:${seconds < 10 ? `0${seconds}` : seconds}`;
        }

        return `${formattedDays}${formattedHours}:${minutes < 10 ? `0${minutes}` : minutes}:${seconds < 10 ? `0${seconds}` : seconds}`;
    };

    async opencliamcashout(evt, cityName) {
        var token = localStorage.getItem('auth_token');
        var decoded = jwt_decode(token);
        var Username = decoded.message.playerid;
        await instance.post("/api/v1/cliamcashout", {
            userid: Username,
            System: Systems,
        }, {
            headers: { Authorization: `Bearer ${token}` }
        }).then(async (res) => {
            if (res.data.status === 200) {
                var decoded = jwt_decode(token);
                var Username = decoded.message.playerid;
                this.rechecklogin(Username, token);
                await this.notify("success", 'ทำรายการรับเงินเรียบร้อย');
            }
            else if (res.data.status === 201) {
                await this.notify("error", 'ไม่สามารถทำรายการได้ ไม่มียอดเงิน');
                return false;
            }
            else if (res.data.status === 202) {
                await this.notify("error", 'ไม่สามารถทำรายการได้');
                return false;
            }

        }).catch(async (err) => {
            // console.log(err);
            if (err.response.status === 401 || err.response.status === 403) {
                localStorage.clear();
                await this.notify("error", 'Session ของท่านหมดอายุ กรุณา login เข้าสู่ระบบอีกครั้ง');
                window.location.href = '/';
            }
        });
    }
    onChangexxxxx = (checked) => {
        console.log(128, checked)
        if (checked == 1) {
            if (this.state.showpassold) {
                this.setState({ showpassold: false });
            }
            else {
                this.setState({ showpassold: true });
            }
        }
        else if (checked == 2) {
            if (this.state.showpassnew) {
                this.setState({ showpassnew: false });
            }
            else {
                this.setState({ showpassnew: true });
            }
        }
        else if (checked == 3) {
            if (this.state.showpasscf) {
                this.setState({ showpasscf: false });
            }
            else {
                this.setState({ showpasscf: true });
            }
        }
    }

    onChangex = event => {
        console.log("✅ CLICK BANK:", event?.target?.value, event?.target?.id);

        if (event.target !== undefined) {
            let nam;
            let val;
            if (event.target.name === undefined) {
                nam = event.name;
                val = event.value;
            } else {
                nam = event.target.name;
                val = event.target.value;
            }
            this.setState({ [nam]: val });
        }
    };

    onChangeselect = event => {
        console.log("✅ CLICK BANK:", event?.target?.value, event?.target?.id);

        this.setState({
            bankselect: event.target.value
        });
        if (event.target.value == 99) {
            this.setState({
                trueaccount: false
            });
        }
        else {
            this.setState({
                trueaccount: true,
                fname: ""
            });
        }

        if (event.target !== undefined) {
            let nam;
            let val;
            if (event.target.name === undefined) {
                nam = event.name;
                val = event.value;
            } else {
                nam = event.target.name;
                val = event.target.value;
            }
            this.setState({ [nam]: val });
        }
    };

    // checkurl = async (e, url) => {
    //     window.history.pushState(null, null, url);

    //     const pathname = window.location.pathname.split("/")
    //     this.setState({
    //         modalx: false,
    //         modal: false,
    //         pathname: pathname[1]
    //     });
    //     console.log(210, pathname[1]);
    //     if (pathname.length > 1) {
    //         if (pathname[1] == "") {
    //             console.log(250, pathname[1]);
    //             this.setState({
    //                 tabselect: 0,
    //             });
    //         }
    //         else if (pathname[1] == "tab") {
    //             this.setState({ loading: true });
    //             if (pathname[2] == "slot") {
    //                 this.setState({
    //                     tabselect: 13,
    //                 });
    //             }
    //             else if (pathname[2] == "fishing") {
    //                 this.setState({
    //                     tabselect: 12,
    //                 });
    //             }
    //             else if (pathname[2] == "sport") {
    //                 this.setState({
    //                     tabselect: 14,
    //                 });
    //             }
    //             else if (pathname[2] == "casino") {
    //                 this.setState({
    //                     tabselect: 10,
    //                 });
    //             }
    //             else if (pathname[2] == "lotto") {
    //                 this.setState({
    //                     tabselect: 17,
    //                 });
    //             }
    //             else if (pathname[2] == "gameshow") {
    //                 this.setState({
    //                     tabselect: 50,
    //                 });
    //             }
    //             await this.getcallprovidor()
    //             this.setState({ loading: false });
    //         }
    //         else if (pathname[1] == "listgameall") {
    //             this.setState({
    //                 tabselect: 99,
    //             });
    //         }
    //         else if (pathname[1] == "luckyfortune") {
    //             this.setState({
    //                 tabselect: 35,
    //             });
    //         }

    //         else if (pathname[1] == "export") {
    //             this.setState({
    //                 tabselect: 51,
    //             });
    //         }
    //         else if (pathname[1] == "slot") {
    //             console.log(101, pathname);
    //             this.setState({
    //                 tabselect: 13,
    //             });
    //         }

    //         else if (pathname[1] == "loss") {
    //             this.setState({
    //                 tabselect: 25,
    //             });
    //         }

    //         else if (pathname[1] == "event") {
    //             this.setState({
    //                 tabselect: 16,
    //             });
    //         }

    //         else if (pathname[1] == "withdraw") {
    //             if (this.state.loginstate) {
    //                 this.setState({
    //                     tabselect: 2,
    //                 });
    //             }
    //             else {
    //                 this.setState({
    //                     tabselect: 0,
    //                 });
    //             }
    //         }
    //         else if (pathname[1] == "deposit") {
    //             if (this.state.loginstate) {
    //                 this.setState({
    //                     tabselect: 1,
    //                     tabselectdeposit: 1,
    //                 });
    //             }
    //             else {
    //                 this.setState({
    //                     tabselect: 0,
    //                 });
    //             }
    //         }
    //         else if (pathname[1] == "statement") {
    //             this.setState({
    //                 tabselect: 3,
    //             });
    //         }
    //         else if (pathname[1] == "profile") {
    //             this.setState({
    //                 tabselect: 8,
    //             });
    //         }
    //         else if (pathname[1] == "register") {
    //             this.setState({
    //                 tabselect: 22,
    //             });
    //         }
    //         else if (pathname[1] == "signin") {
    //             this.setState({
    //                 tabselect: 23,
    //             });
    //         }
    //         else if (pathname[1] + "/" + pathname[2] == "refer/overview") {
    //             this.setState({
    //                 tabselect: 4,
    //                 refer: 1
    //             });
    //         }
    //         else if (pathname[1] + "/" + pathname[2] == "refer/member") {
    //             this.setState({
    //                 tabselect: 4,
    //                 refer: 2
    //             });
    //         }
    //         else if (pathname[1] + "/" + pathname[2] == "refer/income-summary") {
    //             this.setState({
    //                 tabselect: 4,
    //                 refer: 3
    //             });
    //         }
    //         else if (pathname[1] + "/" + pathname[2] == "refer/share-network") {
    //             this.setState({
    //                 tabselect: 4,
    //                 refer: 4
    //             });
    //         }
    //         else if (pathname[1] == "rebate") {
    //             this.setState({
    //                 tabselect: 5,
    //             });
    //         }
    //         else if (pathname[1] == "promotion") {
    //             this.setState({
    //                 tabselect: 7,
    //             });
    //         }
    //         else if (pathname[1] == "listgameall") {
    //             await this.getgame(pathname[2], pathname[3]);
    //             this.setState({
    //                 tabselect: 15,
    //             });
    //         }
    //     }
    //     else {
    //         this.setState({
    //             tabselect: 0,
    //         });
    //     }
    // }

    // เพิ่ม helper นี้ไว้ใน class component
    asyncSetState(newState) {
        return new Promise(resolve => this.setState(newState, resolve));
    }

    // ใช้ checkurl แบบใหม่
    checkurl = async (e, url) => {
        window.history.pushState(null, null, url);
        const pathname = window.location.pathname.split("/");

        const tabMap = {
            "": 0,
            slot: 13,
            fishing: 12,
            sport: 14,
            gamehit: 11,
            casino: 10,
            lotto: 17,
            gamecard: 50,
            listgameall: 99,
            luckyfortune: 35,
            dailycheckin: 36,
            export: 51,
            invitation: 4,
            loss: 25,
            event: 16,
            statement: 3,
            profile: 8,
            register: 22,
            signin: 23,
            rebate: 5,
            promotion: 7
        };
        await this.asyncSetState({
            modalx: false,
            modal: false,
            filteredList: null,
            searchKeyword: "",
            pathname: pathname[1],
            loading: true
        });
        const level1 = pathname[1];
        const level2 = pathname[2];
        if (level1 === "withdraw" || level1 === "deposit") {
            const login = this.state.loginstate;
            await this.asyncSetState({
                tabselect: login ? (level1 === "withdraw" ? 2 : 1) : 0,
                ...(level1 === "deposit" && login ? { tabselectdeposit: 1 } : {})
            });
        } else if (level1 === "refer") {
            const referMap = {
                overview: 1,
                member: 2,
                "income-summary": 3,
                "share-network": 4
            };
            await this.asyncSetState({
                tabselect: 4,
                refer: referMap[level2] || 1
            });
        } else if (level1 === "listgameall" && level2) {
            const innerTabMap = {
                slot: 13,
                fishing: 12,
                gamehit: 11,
                gamecard: 50,
                sport: 14,
                casino: 10,
                lotto: 17,
                gameshow: 50
            };
            const innerTab = innerTabMap[level2];
            await this.getgame(level2, pathname[3]);
            await this.asyncSetState({ tabselect: 99 });
            await this.getcallprovidorcheck(innerTab);
        } else if (level1 === "tab") {
            const innerTabMap = {
                slot: 13,
                fishing: 12,
                gamehit: 11,
                gamecard: 50,
                sport: 14,
                casino: 10,
                lotto: 17,
                gameshow: 50
            };
            const innerTab = innerTabMap[level2];
            if (innerTab) {
                await this.asyncSetState({ tabselect: innerTab });
                await this.getcallprovidor();
            }
        } else if (tabMap[level1] !== undefined) {
            await this.asyncSetState({ tabselect: tabMap[level1] });
        } else {
            await this.asyncSetState({ tabselect: 0 });
        }

        this.setState({ loading: false });
    };


    async calllisthistory(userid) {
        await instance.post("/api/v1/userwithdrawlist", {
            userid: userid,
            Cat_ID: 0,
            System: Systems,
            page: 1,
            type: 1
        }).then((res) => {
            if (res.data.status === 200) {
                const datas = res.data.message;
                //  //console.log(datas.withdrawlist);
                this.setState({
                    historylist: datas.withdrawlist
                });

            }
            else {
                // this.CheckThisGoalError();
            }
        });

    }
    confirmdeposit = async (e, num) => {
        console.log(493, num)
        e.preventDefault();
        var token = localStorage.getItem('auth_token');
        var decoded = jwt_decode(token);
        var Username = decoded.message.playerid;
        if (num === 0) {
            if ((this.state.depositamount >= this.state.limit.min) && (this.state.depositamount <= this.state.limit.max)) {
                if (num === 0) {
                    if (token != null) {
                        Username = decoded.message.playerid;
                        instance.post("/api/v1/getqrcode", {
                            username: Username,
                            System: Systems,
                            amount: this.state.depositamount
                        }, {
                            headers: { Authorization: `Bearer ${token}` }
                        }).then(async (res) => {
                            console.log("tblpaymentgatewayxxxx", res.data)

                            this.setState({
                                mainacc: res.data.mainacc,
                                qrcode: res.data.tblpaymentgatewayx.QRcode,
                                paymentlist: res.data.tblpaymentgatewayx,
                                tabselectsec: 1,
                                tabselectdeposit: 0,
                                counter: 300,
                                qrcodecheck: true,
                            });
                            await this.notify("success", 'กรุณาสแกน qrcode ภายใน 5 นาที');
                        });

                    }

                    this.setState({
                        depositstate: 1
                    });
                }
            }
            else {
                await this.notify("warning", 'เติมขั้นต่ำ ' + this.state.limit.min + ' บาท สูงสุด ' + this.state.limit.max + ' ');

            }
        }
        else if (num === 1) {
            this.setState({
                depositstate: 1
            });
        }

        else if (num === 5) {
            document.getElementById("truemonney").click()
            //deposittruemoneyModal
        }
        else {
            this.setState({
                depositstate: 0
            });
        }



    }
    onChange = async (event) => {
        console.log(event);
        if (event.target !== undefined) {
            let nam;
            let val;
            if (event.target.name === undefined) {
                nam = event.name;
                val = event.value;
            } else {
                nam = event.target.name;
                val = event.target.value;
            }
            if (nam === "withdrawamount") {
                if (this.state.maxwithdrawstatus === 1) {
                    this.setState({ [nam]: this.state.balance });
                    await this.notify("warning", 'บังคับถอนยอดทั้งหมด');
                }
                else if (Number(val) <= Number(this.state.balance)) {
                    this.setState({ [nam]: val });
                }
                else {
                    await this.notify("warning", 'ยอดถอนของท่านไม่เพียงพอในการถอน');

                }
            } else {
                this.setState({ [nam]: val });
            }

        }
    };
    submitwithdraw = async (e) => {
        console.log(this.state.withdrawamount, this.state.balance);
        if (parseFloat(this.state.withdrawamount) <= parseFloat(this.state.balance)) {
            if (parseFloat(this.state.withdrawamount) >= 10) {
                var token = localStorage.getItem('auth_token');
                if (token != null) {
                    var decoded = jwt_decode(token);
                    var Username = decoded.message.playerid;
                    await instance.post("/api/v1/userwithdraw", {
                        User_id: Username,
                        System: Systems,
                        amount: this.state.withdrawamount
                    }, {
                        headers: { Authorization: `Bearer ${token}` }
                    }).then(async (res) => {
                        console.log(res.data);
                        if (res.data.status === 200) {
                            await this.notify("success", 'รายการถอนเรียบร้อย');
                            this.checkurl(e, "/statement")

                        }
                        else if (res.data.status === 203) {
                            await this.notify("error", 'ท่านติด Turnover อีก ' + res.data.amountturnover + " บาท");

                        }
                        else if (res.data.status === 207) {
                            await this.notify("error", 'ขั้นต่ำในการถอน ' + res.data.maxwithdraw + " บาท");

                        }
                        else {
                            await this.notify("error", "ไม่สามารถทำรายการถอนได้ โปรดแจ้งพนักงาน");
                        }
                    });
                }
                else {
                    await this.notify("error", 'รายการถอนมีปัญหา โปรดติดต่อพนักงาน');
                }
            }
            else {
                await this.notify("warning", 'ขั้นต่ำในการถอน 50 บาท');
            }
        }
        else {
            await this.notify("warning", 'ยอดถอนของท่านไม่เพียงพอในการถอน');
        }

    }
    resetpassword = async (e, type) => {
        e.preventDefault();
        const { phoneNumber, fname, password, oldpassword, passwordcf } = this.state;
        console.log(type, password, oldpassword, passwordcf);
        var token = localStorage.getItem('auth_token');
        if (password === passwordcf) {
            var Username = null;
            var decoded = null;
            if (type === 1 && token != null) {
                decoded = jwt_decode(token);
                Username = decoded.message.playerid;
                instance.post("/api/v1/resetpassword", {
                    username: Username,
                    oldpass: oldpassword,
                    System: Systems,
                    newpass: password,
                    type: type
                }, {
                    headers: { Authorization: `Bearer ${token}` }
                }).then(async (res) => {
                    if (res.data.status === 200) {
                        await this.notify("success", 'เปลี่ยนพาสเวิดเรียบร้อย');
                    }
                    else if (res.data.status === 201) {
                        await this.notify("error", 'คุณใส่รหัสเก่าผิดพลาด');
                    }
                    else if (res.data.status === 203) {
                        await this.notify("error", 'มีข้อผิดพลาด โปรดทำรายการอีกครั้ง');
                    }
                    else if (res.data.status === 202) {
                        await this.notify("error", 'คุณใช้พาสเวิดเดิม');
                    }
                });
            }
            else if (type === 2) {
                instance.post("/api/v1/resetpassword", {
                    username: phoneNumber,
                    oldpass: oldpassword,
                    newpass: password,
                    System: Systems,
                    type: type
                }).then(async (res) => {
                    if (res.data.status === 200) {
                        await this.notify("success", 'เปลี่ยนพาสเวิดเรียบร้อย');
                    }
                    else if (res.data.status === 201) {
                        await this.notify("error", 'คุณใส่รหัสเก่าผิดพลาด');
                    }
                    else if (res.data.status === 203) {
                        await this.notify("error", 'มีข้อผิดพลาด โปรดทำรายการอีกครั้ง');
                    }
                    else if (res.data.status === 202) {
                        await this.notify("error", 'คุณใช้พาสเวิดเดิม');
                    }
                });
            }
            else if (type === 3) {
                instance.post("/api/v1/resetpassword", {
                    username: phoneNumber,
                    oldpass: oldpassword,
                    newpass: password,
                    System: Systems,
                    type: type
                }).then(async (res) => {
                    if (res.data.status === 200) {
                        await this.notify("success", 'เปลี่ยนพาสเวิดเรียบร้อย');
                    }
                    else if (res.data.status === 201) {
                        await this.notify("error", 'คุณใส่รหัสเก่าผิดพลาด');
                    }
                    else if (res.data.status === 203) {
                        await this.notify("error", 'มีข้อผิดพลาด โปรดทำรายการอีกครั้ง');
                    }
                    else if (res.data.status === 202) {
                        await this.notify("error", 'คุณใช้พาสเวิดเดิม');
                    }
                });
            }
        }
        else {
            await this.notify("error", 'คุณใส่พาสเวิดไม่ตรงกัน');
        }
    }
    async opencliaminvite(evt, cityName) {
        console.log(cityName);
        var token = localStorage.getItem('auth_token');
        var decoded = jwt_decode(token);
        var Username = decoded.message.playerid;
        await instance.post("/api/v1/cliaminvite", {
            userid: Username,
            System: Systems,
        }, {
            headers: { Authorization: `Bearer ${token}` }
        }).then(async (res) => {
            if (res.data.status === 200) {
                var decoded = jwt_decode(token);
                var Username = decoded.message.playerid;
                this.rechecklogin(Username, token);
                await this.notify("success", 'ทำรายการรับเงินเรียบร้อย');
            }
            else if (res.data.status === 201) {
                await this.notify("error", 'ไม่สามารถทำรายการได้ ไม่มียอดเงิน');
                return false;
            }
            else if (res.data.status === 202) {
                await this.notify("error", 'ไม่สามารถทำรายการได้');
                return false;
            }

        }).catch(async (err) => {
            // console.log(err);
            if (err.response.status === 401 || err.response.status === 403) {
                localStorage.clear();
                await this.notify("warning", 'Session ของท่านหมดอายุ กรุณา login เข้าสู่ระบบอีกครั้ง');
                window.location.href = '/';
            }
        });
    }
    handleClick = async (e, price) => {
        console.log(price);
        if (price <= this.state.balance) {
            this.setState({
                withdrawamount: price
            });
        }
        else {
            await this.notify("warning", 'ยอดถอนของท่านไม่เพียงพอในการถอน');
        }
    }
    handleClickreposit = async (e, price) => {
        this.setState({
            depositamount: price
        });
    }
    redeempro = async (e, proid) => {
        e.preventDefault();
        var token = localStorage.getItem('auth_token');
        var decoded = jwt_decode(token);
        var Username = decoded.message.playerid;
        //console.log(Username, proid);
        if (token != null) {
            this.setState({
                username: Username,
            });
            await instance.post("/api/v1/redeempromotion", {
                userid: Username,
                System: Systems,
                Proid: proid,
            }, {
                headers: { Authorization: `Bearer ${token}` }
            }).then(async (res) => {
                //console.log(res.data.status)
                if (res.data.status === 200) {
                    this.setState({
                        showmodal: false,
                    })
                }
                else if (res.data.status === 201) {
                    await this.notify("error", 'ท่านไม่เข้าเงื่อนใขโปรโมชั่นนี้');
                    e.preventDefault();
                    return false;
                }
                else if (res.data.status === 204) {
                    await this.notify("error", 'ท่านใช้สิทธวันนี้ครบแล้ว');
                    e.preventDefault();
                    return false;
                }
                else if (res.data.status === 202) {
                    await this.notify("error", 'ท่านใช้โปรมั่นชั่นนี้ไปแล้ว');
                    e.preventDefault();
                    return false;
                }

            }).catch(async (err) => {
                // console.log(err);
                if (err.response.status === 401 || err.response.status === 403) {
                    localStorage.clear();
                    await this.notify("error", 'Session ของท่านหมดอายุ กรุณา login เข้าสู่ระบบอีกครั้ง');
                    window.location.href = '/';
                }
            });
        }
    }
    redeem = (e, gameIdx, partner) => {
        var userAgent = navigator.userAgent
        this.checklogin();
        if (!this.state.loginstate) {
            return Swal.fire({
                title: 'error!',
                text: 'คุณยังไม่ได้ทำการล๊อคอิน',
                icon: 'error',
                confirmButtonText: 'ตกลง'
            })
            // return document.getElementById("loginmode").click();
        }
        if (this.state.username !== null) {
            instance.post("/api/v1/tablauncher", {
                gameId: gameIdx,
                partner: partner,
                playerUsername: this.state.username,
                isMobile: isMobile,
                System: Systems,
                demo: false
            })
                .then((res) => {
                    if (res.data.status === 200) {
                        //////console.log(res.data.message);
                        var test = res.data.message.launcher
                        if (test !== undefined) {
                            if (/iPad|iPhone|Macintosh|iPod/.test(userAgent) && !window.MSStream) {
                                window.location.href = test.mobile;
                            }
                            else {
                                if (!isMobile) window.open(test.desktop, '_blank', 'height=1000,width=1000');
                                else window.open(test.mobile);
                            }
                        }
                        else if (test === undefined) {
                            Swal.fire({
                                title: 'error!',
                                text: 'ขณะนี้เกมมีปัญหากรุณารอซักครู่',
                                icon: 'error',
                                confirmButtonText: 'ตกลง'
                            })
                        }
                    }
                    else {
                        //  this.CheckThisGoalError();
                    }
                });
        }
        else {

        }


    }

    couponredeem = async (e, index) => {
        e.preventDefault();
        var token = localStorage.getItem('auth_token');
        if (token != null) {
            var decoded = jwt_decode(token);
            var Username = decoded.message.playerid;
            await instance.post("/api/v1/usercoupon", {
                User_id: Username,
                System: Systems,
                couponkey: this.state.couponkey,
                type: 1
            }).then(async (res) => {
                if (res.data.status === 200) {
                    const datas = res.data.message;
                    await this.notify("success", 'ดำเนินการใช้คูปองเรียบร้อย');
                }
                else {
                    await this.notify("warning", 'ไม่มี Key นี้ในระบบ');
                }
            });
        }
        else {
            await this.notify("warning", 'คุณไม่ได้ล๊อคอิน');
        }

    }
    copyText = (text) => {
        if (navigator.clipboard && window.isSecureContext) {
            // Clipboard API ใช้งานได้ (Chrome, Edge, บาง Safari)
            navigator.clipboard.writeText(text).catch(() => this.fallbackCopy(text));
            toast.success("คัดลอกเรียบร้อย", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        } else {
            // ใช้ fallback สำหรับ Safari หรือเบราว์เซอร์ที่ไม่รองรับ
            this.fallbackCopy(text);
        }
    };

    fallbackCopy = (text) => {
        const textarea = document.createElement("textarea");
        textarea.value = text;
        textarea.style.position = "fixed"; // ป้องกัน scroll กระโดด
        textarea.style.top = 0;
        textarea.style.left = 0;
        document.body.appendChild(textarea);
        textarea.focus();
        textarea.select();

        try {
            document.execCommand("copy");
            toast.success("คัดลอกเรียบร้อย", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        } catch (err) {
            console.error("คัดลอกโดย fallback ล้มเหลว", err);
        }

        document.body.removeChild(textarea);
    };
    copy = async (e, accnumber) => {
        toast.success("คัดลอกเรียบร้อย", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
        });

        navigator.clipboard.writeText(accnumber)
    }
    async callgetthemesv(Systems) {
        await instance.post("/api/v1/getthemesv", {
            System: Systems,
        }).then((res) => {
            if (res.data.status === 200) {
                document.body.setAttribute("data-theme", res.data.ThmeseV)
                this.setState({
                    ThmeseV: res.data.ThmeseV
                });

            }
            else {
                // this.CheckThisGoalError();
            }
        });

    }
    async getgame(typepage, partner) {
        console.log(799, typepage);
        console.log(800, partner);

        await instance.post("/api/v1/tabgamelist", {
            state: "999",
            System: Systems,
            partner: partner,
            game: typepage,
        }).then((res) => {
            console.log(803, res.data);
            if (res.data.status === 200) {
                this.setState({
                    listitallgame: res.data.message
                });
            }
        });
    }
    async getcallprovidor() {
        const stateMap = { 10: "2", 13: "3", 14: "5", 12: "8", 17: "lotto", 22: "1121", 50: "11121", 11: "9"  };
        const stateValue = stateMap[this.state.tabselect];
        if (stateValue) {
            const res = await instance.post("/api/v1/tabgamelist", {
                state: stateValue,
                System: Systems,
            });
            if (res.data.status === 200) {
                this.setState({ categorylist: res.data.message });
            }
        }
    }
    async getcallprovidorcheck(tabselect) {
        const stateMap = { 10: "2", 13: "3", 14: "5", 12: "8", 17: "lotto", 22: "1121", 50: "11121"  , 11: "9"     };

        console.log("tabselect", tabselect);
        console.log("stateMap", stateMap[tabselect]);
        const stateValue = stateMap[tabselect];
        if (stateValue) {
            const res = await instance.post("/api/v1/tabgamelist", {
                state: stateValue,
                System: Systems,
            });
            if (res.data.status === 200) {
                this.setState({
                    providorlist: res.data.message,
                    tabselectprovidor: tabselect
                });
            }
        }
    }

    getCache = (key, ttl) => {
        const cachedData = JSON.parse(localStorage.getItem(key));
        if (cachedData && (Date.now() - cachedData.timestamp < ttl)) {
            return cachedData.data;
        }
        return null;
    };

    setCache = (key, data) => {
        localStorage.setItem(key, JSON.stringify({
            timestamp: Date.now(),
            data: data,
        }));
    };
    async saveclickaff(linkid) {
        await instance.post("/api/v1/saveclickaff", {
            linkid: linkid,
            System: Systems,
        }).then((res) => {
            if (res.data.status == 200) {
                var date = new Date()
                this.setState({
                    userrecomend: res.data.username,
                    link: linkid
                });
                var username = res.data.username
                var object = { date, username }
                localStorage.setItem('aff', JSON.stringify(object))
            }
        }).catch(async (err) => {
        });

    }
    async saveclick(linkid) {
        await instance.post("/api/v1/saveclickaff", {
            linkid: linkid,
            System: Systems,
        }).then((res) => {
            if (res.data.status == 200) {
                var date = new Date()
                var username = res.data.username
                this.setState({
                    userrecomend: username,
                });
                var object = { date, username }
                localStorage.setItem('aff', JSON.stringify(object))
            }
        }).catch(async (err) => {
        });

    }
    async componentDidMount() {
        this.checklogin();
        this.getcallprovidor();
        await this.callgetthemesv(Systems);
        this.promotionlist();

        const search = window.location.href;
        var test = search.split("aff=")[1]
        if (test != undefined) {
            this.saveclickaff(test.split("&")[0]);
        }
        var params = search.split("reg=")[1]
        if (params != undefined) {
            this.saveclick(params);
            this.setState({
                userrecomend: params.split("&")[0],
            });
        }

        var tokenf = localStorage.getItem('aff');
        if (tokenf != null) {
            var codev = JSON.parse(tokenf)
            //   console.log(codev);
            var Username = codev.username;
            this.setState({
                userrecomend: Username,
            });
        }

        var tokenx = localStorage.getItem('register');
        if (tokenx != null) {
            var codev = JSON.parse(tokenx)
            // console.log(codev);
            var Username = codev.username;
            this.setState({
                userrecomend: Username,
            });
        }


        try {
            const pathname = window.location.pathname.split("/");
            const mainSettingKey = "mainSettingCache";
            const mainSettingTTL = 10 * 60 * 1000; // 30 นาที
            var token = localStorage.getItem('auth_token');
            var Playerid = null
            if (token != null) {
                var decoded = jwt_decode(token);
                Playerid = decoded.message.playerid;
            }
            // ตรวจสอบแคชสำหรับ main setting
            const mainSettingCache = this.getCache(mainSettingKey, mainSettingTTL);

            if (mainSettingCache) {
                console.log("Using cached data for main setting");
                const data = mainSettingCache;
                document.title = data.tblsetting[0].title;
                const link = document.querySelector("link[rel*='icon']") || document.createElement('link');
                link.type = 'image/svg+xml';
                link.rel = 'icon';
                link.href = data.tblsetting[0].imglogo;
                document.getElementsByTagName('head')[0].appendChild(link);
                this.setState({
                    webname: data.tblsetting[0].Description,
                    logoimg: data.tblsetting[0].imglogo,
                    whellsetting: data.tblwheelsetting,
                    maxwithdrawstatus: data.tblcatagoryx[0].withdrawmax,
                    luckywheeldisplay: data.tblwheelsetting[0].status === 1,
                    linelink: data.message[1].value,
                    webnamex: data.message[7].value,
                    describemain: data.tblsetting[0].title,
                    System: data.tblcatagoryx[0].System,
                    cashoutSet: data.tblcashoutsetting[0],
                    inviteSet: data.tblinvitedsetting[0],
                    datas: data.message,
                    limit: { min: data.tblcatagoryx[0].limitdeposit, max: data.tblcatagoryx[0].maxdeposit },
                });
            } else {
                await instance.post("/api/v1/mainsetting", {
                    System: Systems,
                    Playerid: Playerid,
                }).then((res) => {
                    console.log(res.data);
                    if (res.data.status === 200) {
                        console.log("luckywheeldisplay", res.data);
                        const datas = res.data.message;
                        const min = res.data.tblcatagoryx[0].limitdeposit;
                        const max = res.data.tblcatagoryx[0].maxdeposit;
                        const maxwithdrawstatus = res.data.tblcatagoryx[0].withdrawmax;
                        const limit = { min, max };
                        const luckywheeldisplay = res.data.tblwheelsetting[0].status === 1;

                        document.title = res.data.tblsetting[0].title;
                        const link = document.querySelector("link[rel*='icon']") || document.createElement('link');
                        link.type = 'image/svg+xml';
                        link.rel = 'icon';
                        link.href = res.data.tblsetting[0].imglogo;
                        document.getElementsByTagName('head')[0].appendChild(link);
                        this.setState({
                            webname: res.data.tblsetting[0].Description,
                            logoimg: res.data.tblsetting[0].imglogo,
                            whellsetting: res.data.tblwheelsetting,
                            maxwithdrawstatus: maxwithdrawstatus,
                            luckywheeldisplay: luckywheeldisplay,
                            linelink: datas[1].value,
                            webnamex: datas[7].value,
                            describemain: res.data.tblsetting[0].title,
                            System: res.data.tblcatagoryx[0].System,
                            cashoutSet: res.data.tblcashoutsetting[0],
                            inviteSet: res.data.tblinvitedsetting[0],
                            datas: datas,
                            limit: limit,
                        });

                        this.setCache(mainSettingKey, res.data);
                    }

                });
            }
            console.log(455, pathname[1] + "/" + pathname[2])
            const getTrueKey = `getTrueCache_${Username}_${Systems}`;
            const getTrueTTL = 30 * 60 * 1000; // 30 นาที
            const getTrueCache = this.getCache(getTrueKey, getTrueTTL);

            if (getTrueCache) {
                console.log("Using cached data for getTrue");
                this.setState({
                    trueaccount: getTrueCache,
                });
            } else {
                await instance.post("/api/v1/gettrue", {
                    userid: Username,
                    System: Systems,
                }, {
                    headers: { Authorization: `Bearer ${token}` }
                }).then((res) => {
                    if (res.data.status === 200) {
                        console.log("not Using cached getTrue", res);
                        const trueAccount = res.data.message.tbltruewallet[0];

                        this.setState({
                            trueaccount: trueAccount,
                        });

                        this.setCache(getTrueKey, trueAccount);
                    }
                }).catch((err) => {
                    console.error("Error fetching getTrue data:", err);
                });
            }
            await this.checkurl(null, window.location.pathname);
            try {
                var token = localStorage.getItem('auth_token');
                console.log("tokentokentoken".token);
                if (token != null) {
                    var decoded = jwt_decode(token);
                    var Username = decoded.message.playerid;
                    await this.rechecklogin(Username, token);
                    this.setState({
                        userid: decoded.message.playerid,
                        username: decoded.message.playerid,
                        firstname: decoded.message.firstname,
                        lastname: decoded.message.lastname,
                        loginstate: true,
                    });
                }
                else {
                    this.setState({
                        loginstate: false,
                    });
                }


            }
            catch (error) {
                console.log(185222, error);
            }
        }
        catch (error) {
            console.log(185222, error);
        }
        if (token != null) {
            var decoded = jwt_decode(token);
            let Username = decoded.message.playerid;
            instance.post("/api/v1/getqrcode", {
                username: Username,
                System: Systems,
                amount: 50
            }, {
                headers: { Authorization: `Bearer ${token}` }
            }).then(async (res) => {
                //////console.log(res.data.picture)
                console.log(16888, res.data.mainacc)
                this.setState({
                    mainacc: res.data.mainacc,
                    paymentgateway: res.data.tblpaymentgatewayx,
                });
            });
        }
    }
    radiocheck(input) {
        console.log(input);
        this.setState({
            bankselect: input
        });
        if (input == 99) {
            this.setState({
                trueaccount: false
            });
        }
        else {
            this.setState({
                trueaccount: true,
                fname: ""
            });
        }
    }
    checktab(e, index) {
        if (index == 2 && this.state.tabselectsec == 1) {

        }
        else if (index == 2 && this.state.tabselectsec == 0) {
            this.setState({
                tabselectdeposit: index,
                tabselectdeposit: 2,
            });
        }
        else {
            console.log(1279, index, this.state.tabselectsec, this.state.qrcode);
            if (index == 2 && this.state.qrcode != null) {
                this.setState({
                    tabselectdeposit: 0,
                    tabselectsec: 1,
                });
            }
            else {
                this.setState({
                    tabselectdeposit: index,
                    tabselectsec: 0,
                });
            }
        }
    }
    openAccout(evt, cityName) {
        var i, tabcontent, tablinks;
        tabcontent = document.getElementsByClassName("x-menu-account-list-sidebar");
        for (i = 0; i < tabcontent.length; i++) {
            tabcontent[i].className += " -open";
        }
    }
    async checkuseradvice() {
        instance.post("/api/v1/checkuseradvice", {
            User_id: this.state.username,
            page: 1,
            System: Systems,
        }).then((res) => {
            if (res.data.status === 200) {
                console.log(res.data.message.useradvicelist);
                this.setState({
                    useradvice: res.data.message.useradvicelist
                });
            }
            else {
                // console.log(res.data);
                // this.CheckThisGoalError();
            }
        });
    }

    openAccoutcan(evt, cityName) {
        var i, tabcontent, tablinks;
        tabcontent = document.getElementsByClassName("x-menu-account-list-sidebar");
        for (i = 0; i < tabcontent.length; i++) {
            tabcontent[i].className = "x-menu-account-list-sidebar";
        }
    }

    async rechecklogin(Username, token) {

        try {
            const search = window.location.href;
            const paramx = new URLSearchParams(search);
            // const space = search.split("/")
            const space = window.location.host
            var userhash = md5(Username);
            //  const linkaff = "https://pgline88.com/?register=" + userhash;
            const linkaff = "https://" + space + "/register?reg=" + userhash;
            instance.post("/api/v1/checkpoint", {
                userid: Username,
                System: Systems,
                Function: 'rechecklogin-navbar.js'
            }, {
                headers: { Authorization: `Bearer ${token}` }
            }).then(async (res) => {
                //  console.log(res.data);

                if (res.data.status === 200) {
                    this.calllisthistory(Username);
                    localStorage.setItem('auth_token', res.data.token)
                    console.log(1067, res.data.userafftoday, res.data.useraffall);
                    this.setState({
                        rankpic: res.data.tblrank?.image,
                        rankname: res.data.tblrank?.name,
                        linkaff: linkaff,
                        rankob: res.data.tblrank,
                        rankpoint: res.data.rankpoint,
                        accnumber: res.data.message.accnumber,
                        userid: res.data.message.member_id,
                        tblprofile: res.data.message,
                        username: res.data.message.playerid,
                        fname: res.data.message.firstname,
                        point: res.data.message.Point,
                        balance: res.data.databalance,
                        afficiatetoday: res.data.userafftoday,
                        afficiateall: res.data.useraffall,
                        loginstate: true,
                    });
                }
                else if (res.data.status === 401) {
                    localStorage.clear();
                    await this.notify("error", 'Session ของท่านหมดอายุ กรุณา login เข้าสู่ระบบอีกครั้ง');
                    window.location.href = '/';
                }

            }).catch(async (err) => {
                console.log(err)
                if (err.response.status === 401 || err.response.status === 403) {
                    localStorage.clear();
                    await this.notify("error", 'Session ของท่านหมดอายุ กรุณา login เข้าสู่ระบบอีกครั้ง');
                    window.location.href = '/';
                }
            });
        }
        catch (ex) {
            //////console.log(ex);
        }

    }
    checkpro = async (e, proid) => {
        console.log(248, proid);
        var Username = "";
        var token = localStorage.getItem('auth_token');
        if (token != null) {
            var decoded = jwt_decode(token);
            Username = decoded.message.playerid;
        }
        await instance.post("/api/v1/checkpromotion", {
            userid: Username,
            System: Systems,
            Proid: proid,
        }, {
            headers: { Authorization: `Bearer ${token}` }
        }).then(async (res) => {
            console.log(res.data)
            if (res.data.status === 200) {
                //console.log(res.data);
                if (res.data.type === 0) {
                    this.setState({
                        showmodal: true,
                        prodetail: res.data.message.tblpromotions[0],
                    });
                }
                else if (res.data.type === 1) {
                    this.setState({
                        showmodal: true,
                        proderedeem: res.data.message.tblpromotionredeems,
                    });
                }



            }
            else if (res.data.status === 201) {
                this.setState({
                    showmodal: true,
                    prodetail: [],
                    picnonpro: "/media/cache/strip/202109/promotion/7AB3F352-6DE2-44CC-A5FC-D4359FCB2122.png",
                });

            }
            else if (res.data.status === 202) {
                await this.notify("success", 'ท่านใช้โปรโมชั่นค้างไว้ สามารถเติมเงินได้เลย');
                return false;
            }

        }).catch(async (err) => {
            //   console.log(err);
            if (err.response.status === 401 || err.response.status === 403) {
                localStorage.clear();
                await this.notify("error", 'Session ของท่านหมดอายุ กรุณา login เข้าสู่ระบบอีกครั้ง');
                window.location.href = '/';
            }
        });
    }


    validateLogout = (e) => {
        console.log(5, "validateLogout")
        localStorage.removeItem('auth_token', '')
        this.setState({
            userid: null,
            username: null,
            password: null,
            firstname: null,
            lastname: null,
            point: null,
            loginstate: false,
        });
    }
    logout = (e) => {
        // e.preventDefault();
        let errors = this.validateLogout();
        if (errors === true) {
            // alert("You are successfully signed in...");
            window.location.reload()
        } else {

            this.setState({
                errors: errors,
                formSubmitted: true
            });
            window.location.reload()
        }
    }
    waitnotify = async () => {
        setTimeout(() => { console.log('World!') }, 5000)
    }
    notify = async (mode, msg) => {
        console.log(mode, msg);
        if (mode == "success") {
            await toast.success(msg, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        }
        else if (mode == "warning") {
            await toast.warning(msg, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        }
        else if (mode == "error") {
            await toast.error(msg, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        }
        else if (mode == "info") {
            await toast.info(msg, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        }
        await this.waitnotify();
    }
    handleSearchClick = () => {
        const keyword = this.state.searchKeyword.toLowerCase().trim();

        const filtered = this.state.listitallgame.filter(item =>
            item.description?.toLowerCase().includes(keyword)
        );

        this.setState({ filteredList: filtered });
    };

    // handleInputChange = (e) => {
    //     const keyword = e.target.value;
    //     this.setState({ searchKeyword: keyword }, () => {
    //         const lower = keyword.toLowerCase().trim();
    //         const filtered = this.state.listitallgame.filter(item =>
    //             item.description?.toLowerCase().includes(lower)
    //         );
    //         this.setState({ filteredList: filtered });
    //     });
    // };
    handleInputChange = (e) => {
        this.setState({ searchKeyword: e.target.value });
    };
    nextstep = async (e, num) => {
        e.preventDefault();
        this.setState({
            disabledbuttonbankaccount: false,
        });
        const { stateregis, password, bankselect, passwordcf, phoneNumber, checkboxacc, fname, otpphone, accnumbertxt } = this.state
        console.log("nextstep", num);
        if (num === 1) {
            if (phoneNumber.length === 10) {
                const check = await this.forgetotpandregister(11);
                console.log("check", check);
                if (phoneNumber.length === 10 && check.checked) {
                    if (check.otpsent.status === true) {

                        if (!check.otpsent.otpcheck) {
                            await this.notify("warning", 'คุณใส่เบอร์ผิดพลาด');
                        }
                        else {
                            this.setState({
                                stateregis: 5
                            });
                        }
                    }
                    else {
                        this.setState({
                            stateregis: 2
                        });
                    }
                }
                else {
                    if (phoneNumber.length !== 10) {
                        await this.notify("warning", 'คุณใส่เบอร์ผิดพลาด');
                    }
                    else if (!check.checked && check.status === 201) {
                        await this.notify("warning", 'เบอร์นี้มีคนใช้แล้ว');
                    }
                    else {
                        await this.notify("warning", 'คุณทำรายการถี่เกินไป โปรด 1 นาทีทำรายการใหม่');
                    }
                }
            }
            else {
                await this.notify("warning", 'คุณใส่เบอร์ผิดพลาด');
            }
        }
        else if (num === 2) {
            console.log("password", password.length);
            if (password !== passwordcf) {
                await this.notify("warning", 'คุณไส่พาสเวิดไม่ตรงกัน');

            }
            else if (password.length < 6) {
                await this.notify("warning", 'คุณต้องไส่พาสเวิดมากกว่า 5 ตัว');

            }
            else {
                this.setState({
                    stateregis: 3,
                    disabledbuttonbankaccount: true,
                });
            }

        }
        else if (num === 3) {
            if (checkboxacc !== 0 && fname !== "" && accnumbertxt !== "") {
                this.setState({
                    stateregis: 3,
                    disabledbuttonbankaccount: true,
                });
            }
            else {
                await this.notify("warning", 'กรุณาเลือกธนาคาร หรือใส่ข้อมูลให้ครบถ้วน');
                //////console.log(2, stateregis, checkboxacc);
            }
        }
        else if (num === 5) {
            var check = await this.forgetotpandregister(12);
            if (otpphone !== "" && check.checked) {
                this.setState({
                    stateregis: 2,
                    disabledbuttonbankaccount: true,
                });
            }
            else if (otpphone === "" || otpphone.length < 4) {
                await this.notify("warning", 'คุณใส่ตัวเลขไม่ครบ');
                document.getElementById("otpphone").style = "border-color: #ef4444;";
                document.getElementById("checkotp").style.display = "block";
            }

            else {
                await this.notify("warning", 'รหัสผิดพลาด');
                document.getElementById("otpphone").style = "border-color: #ef4444;";
                document.getElementById("checkotp").style.display = "block";
            }



        }
        else if (num === 11) {

            console.log(1, stateregis, num);

            this.setState({
                stateregis: 1,
                disabledbuttonbankaccount: true,

            });
        }
        else if (num === 22) {
            //////console.log(1, stateregis, num);
            this.setState({
                stateregis: 2,
                disabledbuttonbankaccount: true,
            });
        }
        else if (num === 25) {
            if (accnumbertxt === "" || typeof accnumbertxt == "undefined") {
                var title = 'error'
                var text = 'คุณไม่ทำการใส่เลขบัญชีธนาคาร'
                var object = { title, text }
                this.modalerror(object);

            }
            else if (accnumbertxt.length < 10) {
                var title = 'error'
                var text = 'คุณยังไม่ได้เลือกธนาคาร'
                var object = { title, text }
                this.modalerror(object);
            }
            else if (bankselect === 0) {
                var title = 'error'
                var text = 'คุณยังไม่ได้เลือกธนาคาร'
                var object = { title, text }
                this.modalerror(object);
            }
            else {
                this.setState({
                    loading: true,
                });
                if (fname === '') {
                    let check = await this.forgetotpandregister(10)
                    if (check.checked) {
                        console.log(302, check.verifications);
                        console.log(302, check.verifications.name);
                        if (check.verifications.status == 0) {
                            this.setState({
                                trueaccount: false,
                                disabledbuttonbankaccount: true,
                            });
                        }
                        else if (check.verifications.status == 1) {
                            this.setState({
                                fname: check.verifications.name,
                                disabledbuttonbankaccount: true,

                            });
                            await this.validatergisterForm(e, check.verifications.name);
                        }
                    }
                    else {
                        var title = 'error'
                        var text = 'เลขบัญชีไม่ถูกต้อง'
                        var object = { title, text }
                        this.modalerror(object);
                    }
                }
                else {
                    await this.validatergisterForm(e, fname)
                }
                this.setState({
                    loading: false
                });
                //console.log(302, check.verifications);
            }


        }
    };
    forgetotpandregister = async (type) => {
        const { phoneNumber, otpphoneforget, checkboxacc, otpphone, accnumbertxt } = this.state;
        var recheck = false;
        if (type === 4) {
            await instance.post("/api/v1/resetpassword", {
                username: phoneNumber,
                System: Systems,
                type: type
            }).then(async (res) => {
                recheck = res.data.message;
            });
        }
        else if (type === 5) {
            await instance.post("/api/v1/resetpassword", {
                username: phoneNumber,
                pin: otpphoneforget,
                System: Systems,
                type: type
            }).then(async (res) => {
                recheck = res.data.message;

            });
        }
        else if (type === 6 || type === 11) {
            await instance.post("/api/v1/resetpassword", {
                username: phoneNumber,
                System: Systems,
                type: type
            }).then(async (res) => {
                recheck = res.data.message;
            });
        }
        else if (type === 7 || type === 12) {
            await instance.post("/api/v1/resetpassword", {
                username: phoneNumber,
                pin: otpphone,
                System: Systems,
                type: type
            }).then(async (res) => {
                recheck = res.data.message;

            });
        }
        else if (type === 10) {
            return await instance.post("/api/v1/resetpassword", {
                accountnumber: accnumbertxt,
                bankid: checkboxacc,
                System: Systems,
                type: type
            }).then(async (res) => {
                return recheck = res.data.message;

            });
        }

        return recheck
    }
    async opencliamcashout(evt, cityName) {
        var token = localStorage.getItem('auth_token');
        var decoded = jwt_decode(token);
        var Username = decoded.message.playerid;
        await instance.post("/api/v1/cliamcashout", {
            userid: Username,
            System: Systems,
        }, {
            headers: { Authorization: `Bearer ${token}` }
        }).then(async (res) => {
            if (res.data.status === 200) {
                var decoded = jwt_decode(token);
                var Username = decoded.message.playerid;
                this.rechecklogin(Username, token);
                this.notify("success", 'ทำรายการรับเงินเรียบร้อย');

            }
            else if (res.data.status === 201) {
                await this.notify("error", 'ไม่สามารถทำรายการได้ ไม่มียอดเงิน');
                return false;
            }
            else if (res.data.status === 202) {
                await this.notify("error", 'ไม่สามารถทำรายการได้');
                return false;
            }

        }).catch(async (err) => {
            // console.log(err);
            if (err.response.status === 401 || err.response.status === 403) {
                localStorage.clear();
                await this.notify("error", 'Session ของท่านหมดอายุ กรุณา login เข้าสู่ระบบอีกครั้ง');
                window.location.href = '/';
            }
        });
    }
    render() {
        const { tabselectprovidor, tabselect, stateopterror, userrecomend, categorylist, fishinglist, sportlist, slotlist, listitallgame, lottolist } = this.state
        const { loginstate, userid, username, point, firstname, lastname, balance, proderedeemlist, linkaff, tblprofile, limit } = this.state
        const { accnumber, paymentgateway, mainacc, trueaccount } = this.state
        var limits = limit
        var accnumberx;
        const tabMap = {
            10: { en: "casino", th: "คาสิโน" },
            11: { en: "gamehit", th: "เกมฮิต" },
            12: { en: "fishing", th: "ยิงปลา" },
            13: { en: "slot", th: "สล็อต" },
            14: { en: "sport", th: "กีฬา" },
            50: { en: "gamecard", th: "ยอดนิยม" },
            17: { en: "lotto", th: "หวย" }
        };
        const tabname = tabMap[tabselect] || { en: "lotto", th: "หวย" };
        const tabnameprovidor = tabMap[tabselectprovidor] || { en: "lotto", th: "หวย" };
        if (accnumber != null) {
            accnumberx = accnumber[0];
        }
        console.log(1326, tabselect, categorylist);
        return (
            <>
                <div >
                    <nav className="x-header navbar navbar-expand-lg -anon">
                        <div className="container-fluid align-items-center h-100 position-relative">
                            <div id="headerBrand">
                                <button type="button" className="btn bg-transparent p-0 x-hamburger js-hamburger-toggle" data-toggle="modal" data-target="#websiteMenuModal">
                                    <span />
                                    <span />
                                    <span />
                                </button>
                                <a className="navbar-brand" href="/">
                                    <img className="-logo" src={this.state.logoimg} alt="Casino slot online logo" />
                                </a>
                            </div>
                            <div className="x-menu">
                                <div className="-menu-container">
                                    <a href="/invitation" className="-menu-link ">
                                        <img
                                            alt="หวยออนไลน์ สล็อตออนไลน์ แทงหวยออนไลน์ เว็บพนันออนไลน์"
                                            className="-icon img-fluid"
                                            width={40}
                                            height={40}
                                            src="/build/web/igame-index-lobby-wm/img/ic-menu-invitation.png"
                                        />
                                        <img
                                            alt="หวยออนไลน์ สล็อตออนไลน์ แทงหวยออนไลน์ เว็บพนันออนไลน์"
                                            className="-icon -active img-fluid"
                                            width={40}
                                            height={40}
                                            src="/build/web/igame-index-lobby-wm/img/ic-menu-invitation-active.png"
                                        />
                                        <span>ชวนเพื่อน</span>
                                    </a>
                                    <a href="/promotion" className="-menu-link ">
                                        <img
                                            alt="หวยออนไลน์ สล็อตออนไลน์ แทงหวยออนไลน์ เว็บพนันออนไลน์"
                                            className="-icon img-fluid"
                                            width={40}
                                            height={40}
                                            src="/build/web/igame-index-lobby-wm/img/ic-menu-promotion.png?v=2"
                                        />
                                        <img
                                            alt="หวยออนไลน์ สล็อตออนไลน์ แทงหวยออนไลน์ เว็บพนันออนไลน์"
                                            className="-icon -active img-fluid"
                                            width={40}
                                            height={40}
                                            src="/build/web/igame-index-lobby-wm/img/ic-menu-promotion-active.png?v=2"
                                        />
                                        <span>โปรโมชั่น</span>
                                    </a>
                                </div>
                            </div>

                            <div id="headerContent">
                                <div className="d-flex">
                                    <a
                                        href={this.state.linelink}
                                        className="x-header-btn-support -in-anon "
                                        target="_blank"
                                        rel="noreferrer nofollow"
                                    >
                                        <picture>
                                            <source
                                                type="image/webp"
                                                srcSet="/build/web/igame-index-lobby-wm/img/ic-telegram-support.webp?v=4"
                                            />
                                            <source
                                                type="image/png?v=4"
                                                srcSet="/build/web/igame-index-lobby-wm/img/ic-telegram-support.png?v=4"
                                            />
                                            <img
                                                alt="หวยออนไลน์ สล็อตออนไลน์ แทงหวยออนไลน์ เว็บพนันออนไลน์"
                                                className="img-fluid -ic"
                                                width={120}
                                                height={39}
                                                src="/build/web/igame-index-lobby-wm/img/ic-telegram-support.png?v=4"
                                            />
                                        </picture>
                                        {/* <picture>
                                            <source
                                                type="image/webp"
                                                srcSet="/build/web/igame-index-lobby-wm/img/ic-telegram-support-mobile.webp?v=4"
                                            />
                                            <source
                                                type="image/png?v=4"
                                                srcSet="/build/web/igame-index-lobby-wm/img/ic-telegram-support-mobile.png?v=4"
                                            />
                                            <img
                                                alt="หวยออนไลน์ สล็อตออนไลน์ แทงหวยออนไลน์ เว็บพนันออนไลน์"
                                                className="img-fluid -ic -mobile"
                                                width={28}
                                                height={28}
                                                src="/build/web/igame-index-lobby-wm/img/ic-telegram-support-mobile.png?v=4"
                                            />
                                        </picture> */}
                                    </a>
                                    <a
                                        href={this.state.linelink}
                                        className="x-header-btn-support -in-anon "
                                        target="_blank"
                                        rel="noreferrer nofollow"
                                    >
                                        <picture>
                                            <source
                                                type="image/webp"
                                                srcSet="/build/web/igame-index-lobby-wm/img/ic-line-support.webp?v=4"
                                            />
                                            <source
                                                type="image/png?v=4"
                                                srcSet="/build/web/igame-index-lobby-wm/img/ic-line-support.png?v=4"
                                            />
                                            <img
                                                alt="หวยออนไลน์ สล็อตออนไลน์ แทงหวยออนไลน์ เว็บพนันออนไลน์"
                                                className="img-fluid -ic"
                                                width={120}
                                                height={39}
                                                src="/build/web/igame-index-lobby-wm/img/ic-line-support.png?v=4"
                                            />
                                        </picture>
                                        <picture>
                                            <source
                                                type="image/webp"
                                                srcSet="/build/web/igame-index-lobby-wm/img/ic-line-support-mobile.webp?v=4"
                                            />
                                            <source
                                                type="image/png?v=4"
                                                srcSet="/build/web/igame-index-lobby-wm/img/ic-line-support-mobile.png?v=4"
                                            />
                                            <img
                                                alt="หวยออนไลน์ สล็อตออนไลน์ แทงหวยออนไลน์ เว็บพนันออนไลน์"
                                                className="img-fluid -ic -mobile"
                                                width={20}
                                                height={20}
                                                src="/build/web/igame-index-lobby-wm/img/ic-line-support-mobile.png?v=4"
                                            />
                                        </picture>
                                    </a>
                                    {loginstate === false && (
                                        <>

                                            <a
                                                href="javascript:void(0)"
                                                className="-btn-header-register btn mr-1 mr-sm-2"
                                                data-toggle="modal"
                                                data-target="#registerModal"
                                            >
                                                สมัครสมาชิก
                                            </a>
                                            <a
                                                href="javascript:void(0)"
                                                className="-btn-header-login btn"
                                                data-toggle="modal"
                                                data-target="#loginModal"
                                            >
                                                เข้าสู่ระบบ
                                            </a>
                                        </>
                                    )}
                                    {loginstate === true && (
                                        <div className="x-logged">
                                            <div className="-profile-outer-container -has-vip-mode">
                                                <div className="-balance-container">
                                                    <div className="-text-username">{username}</div>
                                                    <div className="-user-balance js-user-balance f-sm-6 f-7 ">
                                                        <div className="-inner-box-wrapper">
                                                            <span id="customer-balance" className="js-customer-balance">
                                                                <span className="text-green-lighter"> <NumericFormat value={balance} displayType={'text'} thousandSeparator={true} /></span>
                                                            </span>
                                                            <button
                                                                type="button"
                                                                id="btn-customer-balance-reload"
                                                                className="-btn-balance -in-box"
                                                                onClick={(e) => {
                                                                    this.recheccredit(e)
                                                                }}
                                                                data-target="#customer-balance"
                                                            >
                                                                <i className="fas fa-sync-alt f-9" />
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="-profile-container">
                                                    <a
                                                        href="#account"
                                                        data-toggle="modal"
                                                        data-target="#accountModal"
                                                        className="-btn-wrapper"
                                                    >
                                                        <div className="x-profile-image">
                                                            <img
                                                                className="img-fluid -profile-image"
                                                                src="https://cdn.javisx.com/image/b3dbc674-2f35-4b6b-b5f0-ce92622b50c5.png"
                                                                alt="customer image"
                                                            />
                                                        </div>
                                                    </a>

                                                    <div className="d-xl-none d-block">
                                                        <div className="js-ez-logged-sidebar">

                                                            <div className="x-profile-image">
                                                                <a
                                                                    href={() => false}
                                                                    onClick={this.openAccout}
                                                                >
                                                                    <img
                                                                        className="img-fluid -profile-image"
                                                                        src="https://s3.newworld.center/image/b18efe66-091d-4258-abb2-00dfaf94f75e.webp"
                                                                        alt="customer image"
                                                                    />
                                                                </a>
                                                            </div>
                                                        </div>
                                                        <div className="x-menu-account-list-sidebar">
                                                            <div className="x-modal-account-menu-mobile">
                                                                <div className="-modal-profile-mobile d-xl-none d-block">
                                                                    <div className="text-right">
                                                                        <a href="#account" onClick={this.openAccoutcan}>
                                                                            <i className="fas fa-times f-5 js-close-account-sidebar" />
                                                                        </a>
                                                                    </div>
                                                                    <div className="x-profile-image">
                                                                        <img
                                                                            className="img-fluid -profile-image"
                                                                            src={this.state.rankpic}
                                                                            alt=""
                                                                        />
                                                                    </div>
                                                                    <div className="-balance-container">
                                                                        <div className="-text-username">{username}</div>
                                                                        <div className="-user-balance js-user-balance f-sm-6 f-7 ">
                                                                            <div className="-inner-box-wrapper">
                                                                                <img
                                                                                    className="img-fluid -ic-coin"
                                                                                    src="/build/web/igame-index-lobby-wm/img/ic-coin.png"
                                                                                    alt=""
                                                                                    width={26}
                                                                                    height={21}
                                                                                />
                                                                                <span className="js-customer-balance" id="customer-balance">
                                                                                    {" "}
                                                                                    <span className="-amount"> <NumericFormat value={balance} displayType={'text'} thousandSeparator={true} /></span>
                                                                                </span>
                                                                            </div>
                                                                            <button
                                                                                type="button"
                                                                                className="-btn-balance"
                                                                                id="btn-customer-balance-reload"
                                                                                onClick={(e) => {
                                                                                    this.recheccredit(e)
                                                                                }}
                                                                                data-target="#customer-balance"
                                                                            >
                                                                                <i className="fas fa-sync-alt f-9" />
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="-lists-outer-wrapper">
                                                                    <ul className="navbar-nav">
                                                                        <li className="nav-item -account-profile">
                                                                            <button
                                                                                type="button"
                                                                                className="nav-link js-close-account-sidebar "
                                                                                data-toggle="modal"
                                                                                data-target="#accountModalMobile"
                                                                            >
                                                                                <img
                                                                                    src="/build/web/igame-index-lobby-wm/img/ic-menu-account-user.png"
                                                                                    className="img-fluid -icon-image"
                                                                                    alt="ic-menu-account-user"
                                                                                />
                                                                                <span className="-text-menu">ข้อมูลบัญชี</span>
                                                                            </button>
                                                                        </li>
                                                                        <li className="nav-item -account-provider">
                                                                            <button
                                                                                onClick={(e) => {
                                                                                    this.checkuseradvice()
                                                                                }}
                                                                                type="button"
                                                                                className="nav-link js-close-account-sidebar "
                                                                                data-toggle="modal"
                                                                                data-target="#providerUserModalMobile"
                                                                            >
                                                                                <img
                                                                                    src="/build/web/igame-index-lobby-wm/img/ic-menu-account-provider.png"
                                                                                    className="img-fluid -icon-image"
                                                                                    alt="ic-menu-account-provider"
                                                                                />
                                                                                <span className="-text-menu">ชวนเพื่อน</span>
                                                                            </button>
                                                                        </li>
                                                                        <li className="nav-item -menu-item -account-bill-history">
                                                                            <button
                                                                                type="button"
                                                                                className="nav-link js-close-account-sidebar "
                                                                                data-toggle="modal"
                                                                                data-target="#historyModal"
                                                                            >
                                                                                <img
                                                                                    alt="เมนูใช้งานของผู็ใช้บนเว็บคาสิโนออนไลน์ สล็อตออนไลน์"
                                                                                    className="img-fluid -icon-image"
                                                                                    src="/build/web/igame-index-lobby-wm/img/ic-menu-account-bill-history.png?v=5"
                                                                                />
                                                                                <span className="-text-menu">ประวัติทำรายการ</span>
                                                                            </button>
                                                                        </li>


                                                                        <li className="nav-item -coupon">
                                                                            <button
                                                                                type="button"
                                                                                className="nav-link js-close-account-sidebar js-account-approve-aware"
                                                                                data-toggle="modal"
                                                                                data-target="#couponModalMobile"
                                                                            >
                                                                                <img
                                                                                    src="/build/web/igame-index-lobby-wm/img/ic-menu-account-coupon.png"
                                                                                    className="img-fluid -icon-image"
                                                                                    alt="ic-menu-account-coupon"
                                                                                />
                                                                                <span className="-text-menu">ใช้คูปอง</span>
                                                                            </button>
                                                                        </li>
                                                                        <li className="nav-item -join-promotion">
                                                                            <button
                                                                                type="button"
                                                                                onClick={(e) => {
                                                                                    this.checkpro(e, 999)
                                                                                }}
                                                                                className="nav-link js-close-account-sidebar "
                                                                                data-toggle="modal"
                                                                                data-target="#joinPromotionModalMobile"
                                                                            >
                                                                                <img
                                                                                    src="/build/web/igame-index-lobby-wm/img/ic-menu-account-promotion.png"
                                                                                    className="img-fluid -icon-image"
                                                                                    alt="ic-menu-account-promotion"
                                                                                />
                                                                                <span className="-text-menu">โปรโมชั่นที่เข้าร่วม</span>
                                                                            </button>
                                                                        </li>
                                                                        <li className="nav-item -promotion-return-by-user">
                                                                            <button
                                                                                type="button"
                                                                                className="nav-link js-close-account-sidebar "
                                                                                data-toggle="modal"
                                                                                data-target="#promotionReturnByUserModalMobile"
                                                                            >
                                                                                <img
                                                                                    src="/build/web/igame-index-lobby-wm/img/ic-menu-account-bonus.png"
                                                                                    className="img-fluid -icon-image"
                                                                                    alt="ic-menu-account-bonus"
                                                                                />
                                                                                <span className="-text-menu">รับคืนยอดเสีย</span>
                                                                            </button>
                                                                        </li>
                                                                        <li className="nav-item -logout">
                                                                            <a
                                                                                href="/logout"
                                                                                className="nav-link js-require-confirm"
                                                                                data-title="ต้องการออกจากระบบ ?"
                                                                            >
                                                                                <img
                                                                                    className="img-fluid -icon-image"
                                                                                    src="/build/web/igame-index-lobby-wm/img/ic-menu-account-logout.png"
                                                                                    alt="ic-menu-account-logout"
                                                                                />
                                                                                <span className="-text-menu">ออกจากระบบ</span>
                                                                            </a>
                                                                        </li>
                                                                    </ul>
                                                                    {/* <ul className="navbar-nav -action-nav">
                                                                        <li className="nav-item">
                                                                            <a
                                                                                href={() => false}
                                                                                onClick={this.onClick}
                                                                                className="nav-link js-close-account-sidebar"
                                                                                data-toggle="modal"
                                                                                data-target="#bookmarkModal"
                                                                            >
                                                                                <img
                                                                                    src="/build/web/igame-index-lobby-wm/img/ic-bookmark-square.png"
                                                                                    className="-img"
                                                                                    alt="คาสิโนออนไลน์ สล็อตออนไลน์ บาคาร่าออนไลน์ อันดับ 1"
                                                                                    width={100}
                                                                                    height={100}
                                                                                />
                                                                                <div className="-text">Bookmark</div>
                                                                            </a>
                                                                        </li>
                                                                    </ul> */}
                                                                </div>
                                                            </div>
                                                            <div className="-overlay" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="-deposit-container d-none d-lg-block">
                                                <a
                                                    href="#deposit-choose-promotion"
                                                    className="text-white js-account-approve-aware btn -btn-deposit"
                                                    data-toggle="modal"
                                                    data-target="#depositChoosePromotionModal"
                                                >
                                                    <div className="f-7">ฝากเงิน</div>
                                                </a>
                                            </div>
                                            <div className="-withdraw-container d-none d-lg-block">
                                                <a
                                                    href="#withdraw"
                                                    className="text-white js-account-approve-aware btn -btn-withdraw"
                                                    data-toggle="modal"
                                                    data-target="#withdrawModal"
                                                >
                                                    <div className="f-7">ถอนเงิน</div>
                                                </a>
                                            </div>



                                        </div>)}
                                </div>

                                {/* <div className="navbar-nav">
                                                {(loginstate != null) ? (!loginstate) ?
                                                    <div className="d-flex x-anon ">
                                                        <a href="#loginModal" className="btn -btn-header-login" data-toggle="modal" data-target="#loginModal">
                                                           
                                                            <span className="-text-btn">เข้าสู่ระบบ</span>
                                                        </a>
                                                    </div>
                                                    :
                                                    <div className="x-logged">
                                                        <div className="-deposit-container d-none d-lg-block">
                                                            <a
                                                                href="#deposit-choose-promotion"
                                                                className="text-white js-account-approve-aware btn -btn-deposit"
                                                                data-toggle="modal"
                                                                data-target="#depositChoosePromotionModal"
                                                            >
                                                                <div className="f-7">ฝากเงิน</div>
                                                            </a>
                                                        </div>
                                                        <div className="-withdraw-container d-none d-lg-block">
                                                            <a
                                                                href="#withdraw"
                                                                className="text-white js-account-approve-aware btn -btn-withdraw"
                                                                data-toggle="modal"
                                                                data-target="#withdrawModal"
                                                            >
                                                                <div className="f-7">ถอนเงิน</div>
                                                            </a>
                                                        </div>
                                                        <div className="-profile-container ">
                                                            <div className="d-none d-lg-block">
                                                                <div className="-btn-wrapper">
                                                                    <div className="-inner-wrapper">
                                                                        <a
                                                                            href="#account"
                                                                            data-toggle="modal"
                                                                            data-target="#accountModal"
                                                                            className="text-decoration-none"
                                                                        >
                                                                            <div className="-profile-name">{username}</div>
                                                                        </a>
                                                                        <div className="-balance-container">
                                                                            <div className="-text-username">{username}</div>
                                                                            <div className="-user-balance js-user-balance f-sm-6 f-7 ">
                                                                                <div className="-inner-box-wrapper">
                                                                                    <img
                                                                                        className="img-fluid -ic-coin"
                                                                                        src="/build/web/igame-index-lobby-wm/img/ic-coin.png"
                                                                                        alt=""
                                                                                        width={26}
                                                                                        height={21}
                                                                                    />
                                                                                    <span className="js-customer-balance" id="customer-balance">
                                                                                        {" "}
                                                                                        <span className="-amount"> <NumericFormat value={balance} displayType={'text'} thousandSeparator={true} /> </span>
                                                                                    </span>
                                                                                </div>
                                                                                <button
                                                                                    type="button"
                                                                                    className="-btn-balance"
                                                                                    id="btn-customer-balance-reload"
                                                                                    onClick={(e) => {
                                                                                        this.recheccredit(e)
                                                                                    }}
                                                                                    data-target="#customer-balance"
                                                                                >
                                                                                    <i className="fas fa-sync-alt f-9" />
                                                                                </button>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <a href="#account" data-toggle="modal" data-target="#accountModal">
                                                                        <div className="x-profile-image">
                                                                            <img
                                                                                className="img-fluid -profile-image"
                                                                                src={"/build/rank/" + this.state.rankpic}
                                                                                alt=""
                                                                            />
                                                                        </div>
                                                                    </a>
                                                                </div>
                                                            </div>
                                                            <div className="d-lg-none">
                                                                <div className="js-ez-logged-sidebar -btn-mobile-wrapper">
                                                                    <div className="-inner-wrapper">
                                                                        <a href={() => false}
                                                                            className="text-decoration-none">
                                                                            <div className="-profile-name">{username}</div>
                                                                        </a>
                                                                        <div className="-balance-container">
                                                                            <div className="-text-username">{username}</div>
                                                                            <div className="-user-balance js-user-balance f-sm-6 f-7 ">
                                                                                <div className="-inner-box-wrapper">
            
            
                                                                                    <img
                                                                                        className="img-fluid -ic-coin"
                                                                                        src="/build/web/igame-index-lobby-wm/img/ic-coin.png"
                                                                                        alt=""
                                                                                        width={26}
                                                                                        height={21}
                                                                                    />
                                                                                    <span className="js-customer-balance" id="customer-balance">
                                                                                        {" "}
                                                                                        <span className="-amount">{<NumericFormat value={balance} displayType={'text'} thousandSeparator={true} />}</span>
                                                                                    </span>
                                                                                </div>
                                                                                <button
                                                                                    type="button"
                                                                                    className="-btn-balance"
                                                                                    id="btn-customer-balance-reload"
                                                                                    onClick={(e) => {
                                                                                        this.recheccredit(e)
                                                                                    }}
                                                                                    data-target="#customer-balance"
                                                                                >
                                                                                    <i className="fas fa-sync-alt f-9" />
                                                                                </button>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <a href={() => false}
                                                                        onClick={this.openAccout} >
                                                                        <div className="x-profile-image">
                                                                            <img
                                                                                className="img-fluid -profile-image"
                                                                                src={"/build/rank/" + this.state.rankpic}
                                                                                alt=""
                                                                            />
                                                                        </div>
                                                                    </a>
                                                                </div>
                                                                <div className="x-menu-account-list-sidebar">
                                                                    <div className="x-modal-account-menu-mobile">
                                                                        <div className="-modal-profile-mobile d-xl-none d-block">
                                                                            <div className="text-right">
                                                                                <a href="#account" onClick={this.openAccoutcan}>
                                                                                    <i className="fas fa-times f-5 js-close-account-sidebar" />
                                                                                </a>
                                                                            </div>
                                                                            <div className="x-profile-image">
                                                                                <img
                                                                                    className="img-fluid -profile-image"
                                                                                    src={"/build/rank/" + this.state.rankpic}
                                                                                    alt=""
                                                                                />
                                                                            </div>
                                                                            <div className="-balance-container">
                                                                                <div className="-text-username">{username}</div>
                                                                                <div className="-user-balance js-user-balance f-sm-6 f-7 ">
                                                                                    <div className="-inner-box-wrapper">
                                                                                        <img
                                                                                            className="img-fluid -ic-coin"
                                                                                            src="/build/web/igame-index-lobby-wm/img/ic-coin.png"
                                                                                            alt=""
                                                                                            width={26}
                                                                                            height={21}
                                                                                        />
                                                                                        <span className="js-customer-balance" id="customer-balance">
                                                                                            {" "}
                                                                                            <span className="-amount">{balance}</span>
                                                                                        </span>
                                                                                    </div>
                                                                                    <button
                                                                                        type="button"
                                                                                        className="-btn-balance"
                                                                                        id="btn-customer-balance-reload"
                                                                                        onClick={(e) => {
                                                                                            this.recheccredit(e)
                                                                                        }}
                                                                                        data-target="#customer-balance"
                                                                                    >
                                                                                        <i className="fas fa-sync-alt f-9" />
                                                                                    </button>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div className="-lists-outer-wrapper">
                                                                            <ul className="navbar-nav">
                                                                                <li className="nav-item -account-profile">
                                                                                    <button
                                                                                        type="button"
                                                                                        className="nav-link js-close-account-sidebar "
                                                                                        data-toggle="modal"
                                                                                        data-target="#accountModalMobile"
                                                                                    >
                                                                                        <img
                                                                                            src="/build/web/igame-index-lobby-wm/img/ic-menu-account-user.png"
                                                                                            className="img-fluid -icon-image"
                                                                                            alt="ic-menu-account-user"
                                                                                        />
                                                                                        <span className="-text-menu">ข้อมูลบัญชี</span>
                                                                                    </button>
                                                                                </li>
                                                                                <li className="nav-item -account-provider">
                                                                                    <button
                                                                                        onClick={(e) => {
                                                                                            this.checkuseradvice()
                                                                                        }}
                                                                                        type="button"
                                                                                        className="nav-link js-close-account-sidebar "
                                                                                        data-toggle="modal"
                                                                                        data-target="#providerUserModalMobile"
                                                                                    >
                                                                                        <img
                                                                                            src="/build/web/igame-index-lobby-wm/img/ic-menu-account-provider.png"
                                                                                            className="img-fluid -icon-image"
                                                                                            alt="ic-menu-account-provider"
                                                                                        />
                                                                                        <span className="-text-menu">ชวนเพื่อน</span>
                                                                                    </button>
                                                                                </li>
                                                                                <li className="nav-item -menu-item -account-bill-history">
                                                                                    <button
                                                                                        type="button"
                                                                                        className="nav-link js-close-account-sidebar "
                                                                                        data-toggle="modal"
                                                                                        data-target="#historyModal"
                                                                                    >
                                                                                        <img
                                                                                            alt="เมนูใช้งานของผู็ใช้บนเว็บคาสิโนออนไลน์ สล็อตออนไลน์"
                                                                                            className="img-fluid -icon-image"
                                                                                            src="/build/web/igame-index-lobby-wm/img/ic-menu-account-bill-history.png?v=5"
                                                                                        />
                                                                                        <span className="-text-menu">ประวัติทำรายการ</span>
                                                                                    </button>
                                                                                </li>
            
            
                                                                                <li className="nav-item -coupon">
                                                                                    <button
                                                                                        type="button"
                                                                                        className="nav-link js-close-account-sidebar js-account-approve-aware"
                                                                                        data-toggle="modal"
                                                                                        data-target="#couponModalMobile"
                                                                                    >
                                                                                        <img
                                                                                            src="/build/web/igame-index-lobby-wm/img/ic-menu-account-coupon.png"
                                                                                            className="img-fluid -icon-image"
                                                                                            alt="ic-menu-account-coupon"
                                                                                        />
                                                                                        <span className="-text-menu">ใช้คูปอง</span>
                                                                                    </button>
                                                                                </li>
                                                                                <li className="nav-item -join-promotion">
                                                                                    <button
                                                                                        type="button"
                                                                                        onClick={(e) => {
                                                                                            this.checkpro(e, 999)
                                                                                        }}
                                                                                        className="nav-link js-close-account-sidebar "
                                                                                        data-toggle="modal"
                                                                                        data-target="#joinPromotionModalMobile"
                                                                                    >
                                                                                        <img
                                                                                            src="/build/web/igame-index-lobby-wm/img/ic-menu-account-promotion.png"
                                                                                            className="img-fluid -icon-image"
                                                                                            alt="ic-menu-account-promotion"
                                                                                        />
                                                                                        <span className="-text-menu">โปรโมชั่นที่เข้าร่วม</span>
                                                                                    </button>
                                                                                </li>
                                                                                <li className="nav-item -promotion-return-by-user">
                                                                                    <button
                                                                                        type="button"
                                                                                        className="nav-link js-close-account-sidebar "
                                                                                        data-toggle="modal"
                                                                                        data-target="#promotionReturnByUserModalMobile"
                                                                                    >
                                                                                        <img
                                                                                            src="/build/web/igame-index-lobby-wm/img/ic-menu-account-bonus.png"
                                                                                            className="img-fluid -icon-image"
                                                                                            alt="ic-menu-account-bonus"
                                                                                        />
                                                                                        <span className="-text-menu">รับคืนยอดเสีย</span>
                                                                                    </button>
                                                                                </li>
                                                                                <li className="nav-item -logout">
                                                                                    <a
                                                                                        href="/logout"
                                                                                        className="nav-link js-require-confirm"
                                                                                        data-title="ต้องการออกจากระบบ ?"
                                                                                    >
                                                                                        <img
                                                                                            className="img-fluid -icon-image"
                                                                                            src="/build/web/igame-index-lobby-wm/img/ic-menu-account-logout.png"
                                                                                            alt="ic-menu-account-logout"
                                                                                        />
                                                                                        <span className="-text-menu">ออกจากระบบ</span>
                                                                                    </a>
                                                                                </li>
                                                                            </ul>
                                                                            <ul className="navbar-nav -action-nav">
                                                                                <li className="nav-item">
                                                                                    <a
                                                                                        href={() => false}
                                                                                        onClick={this.onClick}
                                                                                        className="nav-link js-close-account-sidebar"
                                                                                        data-toggle="modal"
                                                                                        data-target="#bookmarkModal"
                                                                                    >
                                                                                        <img
                                                                                            src="/build/web/igame-index-lobby-wm/img/ic-bookmark-square.png"
                                                                                            className="-img"
                                                                                            alt="คาสิโนออนไลน์ สล็อตออนไลน์ บาคาร่าออนไลน์ อันดับ 1"
                                                                                            width={100}
                                                                                            height={100}
                                                                                        />
                                                                                        <div className="-text">Bookmark</div>
                                                                                    </a>
                                                                                </li>
                                                                            </ul>
                                                                        </div>
                                                                    </div>
                                                                    <div className="-overlay" />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div> : ""
                                                }
                                            </div> */}
                            </div>
                        </div>

                    </nav>

                </div>

                <section className="x-index-top-container" data-animatable="fadeInModal">
                    <div className="-index-inner-wrapper" >
                        <div className="x-special-menu-entry-wrapper js-special-menu-entry-wrapper">
                            <div className="container">
                                <div className="x-special-menu-entry -main-container">
                                    <ul className="nav -nav">
                                        <li className="nav-item">
                                            <a
                                                onClick={(e) => {
                                                    this.checkurl(e, "/luckyfortune")
                                                }}
                                                role='button'
                                                className="nav-link -menu-birth-date animated fadeInUp"
                                                target="_blank"
                                                rel="nofollow noopener"
                                                data-animatable="fadeInUp"
                                                data-delay={200}
                                            >
                                                <img
                                                    alt="aexy club "
                                                    className="-bg"
                                                    src="/build/web/igame-index-lobby-ae-sexy/img/special-menu-entry-item-bg.png?v=1"
                                                />
                                                <img
                                                    alt="aexy club "
                                                    className="-text-img img-fluid"
                                                    src="/build/web/igame-index-lobby-ae-sexy/img/special-menu-entry-wheel.png?v=1"
                                                />
                                            </a>
                                        </li>
                                        <li className="nav-item">
                                            {loginstate === false ? (
                                                <a
                                                    href={"https://lin.ee/SrGTcvP"}
                                                    className="nav-link -menu-birth-date animated fadeInUp"
                                                    target="_blank"
                                                    rel="nofollow noopener"
                                                    data-animatable="fadeInUp"
                                                    data-delay={200}
                                                >
                                                    <img
                                                        alt="aexy club"
                                                        className="-bg"
                                                        src="/build/web/igame-index-lobby-ae-sexy/img/special-menu-entry-item-bg.png?v=1"
                                                    />
                                                    <img
                                                        alt="aexy club"
                                                        className="-text-img img-fluid"
                                                        src="/build/web/igame-index-lobby-ae-sexy/img/special-menu-entry-social-share.png?v=1"
                                                    />
                                                </a>
                                            ) : (
                                                <a
                                                    href={"https://lin.ee/SrGTcvP"}
                                                    className="nav-link -menu-birth-date animated fadeInUp"
                                                    target="_blank"
                                                    rel="nofollow noopener"
                                                    data-animatable="fadeInUp"
                                                    data-delay={200}
                                                >
                                                    <img
                                                        alt="AE SEXY Image"
                                                        className="-bg"
                                                        src="/build/web/igame-index-lobby-ae-sexy/img/special-menu-entry-item-bg.png?v=1"
                                                    />
                                                    <img
                                                        alt="AE SEXY Image"
                                                        className="-text-img img-fluid"
                                                        src="/build/web/igame-index-lobby-ae-sexy/img/special-menu-entry-social-share.png?v=1"
                                                    />
                                                </a>
                                            )}

                                        </li>
                                        <li className="nav-item">
                                            <a
                                                href={"https://lin.ee/SrGTcvP"}
                                                className="nav-link -menu-birth-date animated fadeInUp"
                                                target="_blank"
                                                rel="nofollow noopener"
                                                data-animatable="fadeInUp"
                                                data-delay={200}
                                            >
                                                <img
                                                    alt="aexy club "
                                                    className="-bg"
                                                    src="/build/web/igame-index-lobby-ae-sexy/img/special-menu-entry-item-bg.png?v=1"
                                                />
                                                <img
                                                    alt="aexy club "
                                                    className="-text-img img-fluid"
                                                    src="/build/web/igame-index-lobby-ae-sexy/img/special-menu-entry-bind-social.png?v=1"
                                                />
                                            </a>
                                        </li>
                                        <li className="nav-item">
                                            <a
                                                onClick={(e) => {
                                                    this.checkurl(e, "/invitation")
                                                }}
                                                style={{ cursor: "pointer" }}
                                                role='button'
                                                className="nav-link -menu-birth-date animated fadeInUp"
                                                data-animatable="fadeInUp"
                                                data-delay={200}
                                            >
                                                <img
                                                    alt="aexy club "
                                                    className="-bg"
                                                    src="/build/web/igame-index-lobby-ae-sexy/img/special-menu-entry-item-bg.png?v=1"
                                                />
                                                <img
                                                    alt="aexy club "
                                                    className="-text-img img-fluid"
                                                    src="/build/web/igame-index-lobby-ae-sexy/img/special-menu-entry-invitation.png?v=1"
                                                />
                                            </a>
                                        </li>
                                        <li className="nav-item">
                                            <a
                                                href={"https://lin.ee/SrGTcvP"}
                                                className="nav-link -menu-birth-date animated fadeInUp"
                                                target="_blank"
                                                rel="nofollow noopener"
                                                data-animatable="fadeInUp"
                                                data-delay={200}
                                            >
                                                <img
                                                    alt="aexy club "
                                                    className="-bg"
                                                    src="/build/web/igame-index-lobby-ae-sexy/img/special-menu-entry-item-bg.png?v=1"
                                                />
                                                <img
                                                    alt="aexy club "
                                                    className="-text-img img-fluid"
                                                    src="/build/web/igame-index-lobby-ae-sexy/img/special-menu-entry-happy-birth-day.png?v=1"
                                                />
                                            </a>
                                        </li>
                                        {/* <li className="nav-item">
                                <a
                                    href="#"
                                    className="nav-link -menu-ranking animated fadeInUp"
                                    data-animatable="fadeInUp"
                                    data-delay={250}
                                >
                                    <img
                                        alt="aexy club "
                                        className="-bg"
                                        src="/build/web/igame-index-lobby-ae-sexy/img/special-menu-entry-item-bg.png?v=1"
                                    />
                                    <img
                                        alt="aexy club "
                                        className="-text-img img-fluid"
                                        src="/build/web/igame-index-lobby-ae-sexy/img/special-menu-entry-ranking.png?v=1"
                                    />
                                </a>
                            </li> */}
                                        <li className="nav-item">
                                            <a
                                                href={"https://lin.ee/SrGTcvP"}
                                                className="nav-link -menu-movie animated fadeInUp"
                                                target="_blank"
                                                rel="nofollow noopener"
                                                data-animatable="fadeInUp"
                                                data-delay={300}
                                            >
                                                <img
                                                    alt="aexy club "
                                                    className="-bg"
                                                    src="/build/web/igame-index-lobby-ae-sexy/img/special-menu-entry-item-bg.png?v=1"
                                                />
                                                <img
                                                    alt="aexy club "
                                                    className="-text-img img-fluid"
                                                    src="/build/web/igame-index-lobby-ae-sexy/img/special-menu-entry-movie.png?v=1"
                                                />
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <Listmenu />
                        <br></br>
                        <div className="-games-provider-wrapper" data-animatable="fadeInModal">
                            <NavMenu />

                            <div style={{ display: this.state.tabselect == 3 ? "" : "none" }}>
                                {this.state.tabselect == 3 && (
                                    <Statement userid={this.state.username}
                                        loginstate={this.state.loginstate} />
                                )}
                            </div>
                            <div style={{ display: this.state.tabselect == 8 ? "" : "none" }}>
                                {this.state.tabselect == 8 && (
                                    <Profile userid={this.state.username}
                                        loginstate={this.state.loginstate} />
                                )}
                            </div>
                            <div style={{ display: this.state.tabselect == 4 ? "" : "none" }}>
                                {this.state.tabselect == 4 && (
                                    <Afficiate userid={this.state.username}
                                        loginstate={this.state.loginstate} />
                                )}
                            </div>
                            <div style={{ display: this.state.tabselect == 23 ? "" : "none" }}>
                                {this.state.tabselect == 23 && (
                                    <Signin userid={this.state.username}
                                        loginstate={this.state.loginstate} />
                                )}
                            </div>
                            <div style={{ display: this.state.tabselect == 22 ? "" : "none" }}>
                                {this.state.tabselect == 22 && (
                                    <Register userid={this.state.username}
                                        loginstate={this.state.loginstate} />
                                )}
                            </div>
                            <div style={{ display: this.state.tabselect == 25 ? "" : "none" }}>
                                {this.state.tabselect == 25 && (
                                    <Loss userid={this.state.username}
                                        loginstate={this.state.loginstate} />
                                )}
                            </div>

                            <div style={{ display: this.state.tabselect == 35 ? "" : "none" }}>
                                {this.state.tabselect == 35 && (
                                    <Luckyfortune
                                        userid={this.state.username}
                                        loginstate={this.state.loginstate}
                                        point={this.state.point}
                                        onNavigate={(to, e) => {
                                            if (e?.preventDefault) e.preventDefault();
                                            window.history.pushState(null, "", to);
                                            // เรียกฟังก์ชันกลางของคุณ
                                            this.checkurl(e, to); // หรือ checkurl(e, to)
                                        }}
                                    />
                                )}
                            </div>
                            <div style={{ display: this.state.tabselect == 36 ? "" : "none" }}>
                                {this.state.tabselect == 36 && (
                                    <Checkindaily
                                        userid={this.state.username}
                                        loginstate={this.state.loginstate}
                                        onNavigate={(to, e) => {
                                            if (e?.preventDefault) e.preventDefault();
                                            window.history.pushState(null, "", to);
                                            // เรียกฟังก์ชันกลางของคุณ
                                            this.checkurl(e, to); // หรือ checkurl(e, to)
                                        }}
                                    />
                                )}
                            </div>
                            <div style={{ display: this.state.tabselect == 7 ? "" : "none" }}>
                                {this.state.tabselect == 7 && (
                                    <Promotion userid={this.state.username}
                                        loginstate={this.state.loginstate}
                                    />

                                )}
                            </div>

                            <div style={{ display: this.state.tabselect === 10 || this.state.tabselect === 17 || this.state.tabselect === 99 || this.state.tabselect === 15 || this.state.tabselect === 14 || this.state.tabselect === 13 || this.state.tabselect === 12 || this.state.tabselect === 0 || this.state.tabselect === 11|| this.state.tabselect === 50  ? "" : "none" }}>
                                <div className="-games-index-page">
                                    <div className="x-category-provider js-game-scroll-container js-game-container">
                                        <div className="-games-list-container container">
                                            <div className="x-hot-games-container">
                                                {/* {(this.state.recentmenu) ?
                                                    <div>
                                                        <div className="-inner-heading-wrapper">
                                                            <img src="https://asset.cloudigame.co/build/admin/img/wt_theme/ezc/ic-nav-menu-popular-2.png" className="-icon" alt="เกมคาสิโนยอดนิยม เกมสล็อตยอดนิยม" width={55} height={55} />
                                                            <h2 className="-title">เล่นล่าสุด</h2>
                                                        </div>
                                                        <nav className="nav-menu" id="navbarProvider">
                                                            <ul className="nav nav-pills">
                                                                {this.state.recentlist.map((listitem, i) => (
                                                                    <li
                                                                        key={i} id={listitem.gameid}
                                                                        className="nav-item -game-slot-macro-container -square">
                                                                        <a
                                                                            href={() => false}
                                                                            onClick={(e) => this.redeem(e, listitem.gameId, listitem.partner)}
                                                                            className="nav-link js-account-approve-aware"
                                                                            rel="nofollow noopener"
                                                                        >
                                                                            <div className="x-game-list-item-macro js-game-list-toggle -normal " data-status>
                                                                                <div className="-inner-wrapper">
                                                                                    <img
                                                                                        src={listitem.image}
                                                                                        width={250} height={250}
                                                                                        className="-cover-img lazyload img-fluid" alt="Crown & Anchor | evo-play เว็บคาสิโนออนไลน์ สล็อตออนไลน์ รับเครดิตฟรี" />
                                                                                    <div className="-overlay">
                                                                                        <div className="-overlay-inner">
                                                                                            <div className="-wrapper-container">
                                                                                                <button
                                                                                                    //  href={"/listgameall/" + tabname.en + "/" + listitem.partner}
                                                                                                    className="-btn -btn-play js-account-approve-aware" >
                                                                                                    <i className="fas fa-play"></i>
                                                                                                    <span className="-text-btn">เข้าเล่น</span>
                                                                                                </button>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                                <div className="-title">{listitem.description}</div>
                                                                            </div>
                                                                        </a>
                                                                    </li>
                                                                ))}
                                                            </ul>
                                                        </nav>
                                                    </div>
                                                    : ""
                                                } */}
                                                <div className="x-category-index -v3">
                                                    <div className="-nav-menu-container js-category-menus -in-homepage">
                                                        {loginstate === true ? (<div className="x-quick-transaction-buttons js-quick-transaction-buttons -in-category ">
                                                            <a className="btn -btn -invitation  -vertical" href="/invitation">
                                                                <span className="-ic-wrapper">
                                                                    {" "}
                                                                    <img
                                                                        alt="แนะนำเพื่อนที่คุณรัก กับระบบการหาเงินรูปแบบใหม่ เพื่อลูกค้าคนสำคัญ"
                                                                        className="img-fluid -ic"
                                                                        width={40}
                                                                        height={40}
                                                                        src="https://asset.cloudigame.co/build/admin/img/wt_theme/ezl/ic-quick-transaction-button-invite.png"
                                                                    />
                                                                </span>
                                                                <span className="-btn-inner-content">
                                                                    <span className="-btn-inner-content-title">แนะนำเพื่อน</span>
                                                                </span>
                                                            </a>
                                                            <button
                                                                className="btn -btn -notification  -vertical"
                                                                data-toggle="modal"
                                                                data-target="#notificationCenterModal"
                                                            >
                                                                <span className="-ic-wrapper">
                                                                    {" "}
                                                                    <img
                                                                        alt="กระดิ่งแจ้งเตือน เพื่อลูกค้าคนสำคัญ"
                                                                        className="img-fluid -ic"
                                                                        width={40}
                                                                        height={40}
                                                                        src="/build/web/igame-index-lobby-wm/img/ic-quick-transaction-button-notification.png?v=2"
                                                                    />
                                                                </span>
                                                                <span className="-btn-inner-content">
                                                                    <span className="-btn-inner-content-title">แจ้งเตือน</span>
                                                                </span>
                                                            </button>
                                                            <a
                                                                className="btn -btn -promotion  -vertical"
                                                                onClick={(e) => {
                                                                    this.checkurl(e, "/promotion")
                                                                }}
                                                                rel="noopener nofollow"
                                                            >
                                                                <span className="-ic-wrapper">
                                                                    {" "}
                                                                    <img
                                                                        alt="โปรโมชั่นสุดคุ้ม เพื่อลูกค้าคนสำคัญ"
                                                                        className="img-fluid -ic"
                                                                        width={40}
                                                                        height={40}
                                                                        src="/build/web/igame-index-lobby-wm/img/ic-quick-transaction-button-promotion.png?v=2"
                                                                    />
                                                                </span>
                                                                <span className="-btn-inner-content">
                                                                    <span className="-btn-inner-content-title">โปรโมชั่น</span>
                                                                </span>
                                                            </a>
                                                            <button
                                                                className="btn -btn -deposit "
                                                                data-toggle="modal"
                                                                data-target="#depositChoosePromotionModal"
                                                            >
                                                                <span className="-btn-inner-content">
                                                                    <span className="-btn-inner-content-title">ฝาก</span>
                                                                </span>
                                                            </button>
                                                            <button
                                                                className="btn -btn -withdraw "
                                                                data-toggle="modal"
                                                                data-target="#withdrawModal"
                                                            >
                                                                <span className="-btn-inner-content">
                                                                    <span className="-btn-inner-content-title">ถอน</span>
                                                                </span>
                                                            </button>
                                                        </div>
                                                        ) : (<>    </>)}

                                                        <div className="container">
                                                            <nav className="nav-menu" id="navbarCategory">
                                                                <ul
                                                                    className="-menu-parent navbar-nav js-menu-container -left"
                                                                    id="accordion-games"
                                                                >
                                                                    <li className="-list-parent nav-item">
                                                                        <a
                                                                            onClick={(e) => {
                                                                                this.checkurl(e, "/tab/gamehit")
                                                                            }}
                                                                            role="button"
                                                                            data-target=".js-game-container"
                                                                            data-menu-container=".js-menu-container"
                                                                            className={`x-category-button -v3 js-casino -category-casino ${tabselect === 11 || tabselect === 0 ? 'active' : ''} -category-button-icon -hoverable`}
                                                                        >
                                                                            <img
                                                                                alt="category slot image png"
                                                                                className="-default -icon"
                                                                                width={50}
                                                                                height={50}
                                                                                src="https://cdn.javisx.com/image/3742cf82-9809-42a8-8d6c-7d6a708cce2d.png"
                                                                            />
                                                                            <img
                                                                                alt="category slot image png"
                                                                                className="-hover -icon"
                                                                                width={50}
                                                                                height={50}
                                                                                src="https://cdn.javisx.com/image/3742cf82-9809-42a8-8d6c-7d6a708cce2d.png"
                                                                            />
                                                                            <div className="-menu-text-wrapper">
                                                                                <span className="-text-desktop">ยอดนิยม</span>
                                                                                <span className="-text-mobile">ยอดนิยม</span>
                                                                            </div>
                                                                        </a>
                                                                    </li>
                                                                    <li className="-list-parent nav-item">
                                                                        <a
                                                                            onClick={(e) => {
                                                                                this.checkurl(e, "/tab/casino")
                                                                            }}

                                                                            role="button"
                                                                            data-menu-container=".js-menu-container"
                                                                            className={`x-category-button -v3 js-casino -category-casino ${tabselect === 10 ? 'active' : ''} -category-button-icon -hoverable`}
                                                                        >
                                                                            <img
                                                                                alt="category slot image png"
                                                                                className="-default -icon"
                                                                                width={50}
                                                                                height={50}
                                                                                src="/build/web/igame-index-lobby-wm/img/menu-icon-category-baccarat-vip.png?v=4"
                                                                            />
                                                                            <img
                                                                                alt="category slot image png"
                                                                                className="-hover -icon"
                                                                                width={50}
                                                                                height={50}
                                                                                src="/build/web/igame-index-lobby-wm/img/menu-icon-category-baccarat-vip-hover.png?v=4"
                                                                            />
                                                                            <div className="-menu-text-wrapper">
                                                                                <span className="-text-desktop">คาสิโน</span>
                                                                                <span className="-text-mobile">คาสิโน</span>
                                                                            </div>
                                                                        </a>
                                                                    </li>
                                                                    <li className="-list-parent nav-item">
                                                                        <a
                                                                            onClick={(e) => {
                                                                                this.checkurl(e, "/tab/gamecard")
                                                                            }}
                                                                            role="button"
                                                                            data-target=".js-game-container"
                                                                            data-menu-container=".js-menu-container"
                                                                            className={`x-category-button -v3 js-casino -category-casino ${tabselect === 50 || tabselect === 0 ? 'active' : ''} -category-button-icon -hoverable`}
                                                                        >
                                                                            <img
                                                                                alt="category slot image png"
                                                                                className="-default -icon"
                                                                                width={50}
                                                                                height={50}
                                                                                src="https://idea-bet.live/theme/m4bet88/wp-content/uploads/2022/04/01-1.png"
                                                                            />
                                                                            <img
                                                                                alt="category slot image png"
                                                                                className="-hover -icon"
                                                                                width={50}
                                                                                height={50}
                                                                                src="https://idea-bet.live/theme/m4bet88/wp-content/uploads/2022/04/01-1.png"
                                                                            />
                                                                            <div className="-menu-text-wrapper">
                                                                                <span className="-text-desktop">เกมส์ไพ่</span>
                                                                                <span className="-text-mobile">เกมส์ไพ่</span>
                                                                            </div>
                                                                        </a>
                                                                    </li>

                                                                    <li className="-list-parent nav-item">
                                                                        <a
                                                                            onClick={(e) => {
                                                                                this.checkurl(e, "/tab/slot")
                                                                            }}
                                                                            role="button"
                                                                            data-menu-container=".js-menu-container"
                                                                            className={`x-category-button -v3 js-casino -category-casino ${tabselect === 13 ? 'active' : ''} -category-button-icon -hoverable`}
                                                                        >
                                                                            <img
                                                                                alt="category slot image png"
                                                                                className="-default -icon"
                                                                                width={50}
                                                                                height={50}
                                                                                src="/build/web/igame-index-lobby-wm/img/menu-icon-category-slot.png?v=4"
                                                                            />
                                                                            <img
                                                                                alt="category slot image png"
                                                                                className="-hover -icon"
                                                                                width={50}
                                                                                height={50}
                                                                                src="/build/web/igame-index-lobby-wm/img/menu-icon-category-slot-hover.png?v=4"
                                                                            />
                                                                            <div className="-menu-text-wrapper">
                                                                                <span className="-text-desktop">สล็อต</span>
                                                                                <span className="-text-mobile">สล็อต</span>
                                                                            </div>
                                                                        </a>
                                                                    </li>
                                                                    <li className="-list-parent nav-item">
                                                                        <a
                                                                            onClick={(e) => {
                                                                                this.checkurl(e, "/tab/sport")
                                                                            }}
                                                                            role="button"
                                                                            data-menu-container=".js-menu-container"
                                                                            className={`x-category-button -v3 js-casino -category-casino ${tabselect === 14 ? 'active' : ''} -category-button-icon -hoverable`}
                                                                        >
                                                                            <img
                                                                                alt="category slot image png"
                                                                                className="-default -icon"
                                                                                width={50}
                                                                                height={50}
                                                                                src="/build/web/igame-index-lobby-wm/img/menu-icon-category-sport.png?v=4"
                                                                            />
                                                                            <img
                                                                                alt="category slot image png"
                                                                                className="-hover -icon"
                                                                                width={50}
                                                                                height={50}
                                                                                src="/build/web/igame-index-lobby-wm/img/menu-icon-category-sport-hover.png?v=4"
                                                                            />
                                                                            <div className="-menu-text-wrapper">
                                                                                <span className="-text-desktop">กีฬา</span>
                                                                                <span className="-text-mobile">กีฬา</span>
                                                                            </div>
                                                                        </a>
                                                                    </li>

                                                                    <li className="-list-parent nav-item">
                                                                        <a
                                                                            onClick={(e) => {
                                                                                this.checkurl(e, "/tab/fishing")
                                                                            }}
                                                                            role="button"
                                                                            data-target=".js-game-container"
                                                                            data-menu-container=".js-menu-container"
                                                                            className={`x-category-button -v3 js-casino -category-casino ${tabselect === 12 ? 'active' : ''} -category-button-icon -hoverable`}
                                                                        >
                                                                            <img
                                                                                alt="category slot image png"
                                                                                className="-default -icon"
                                                                                width={50}
                                                                                height={50}
                                                                                src="/build/web/igame-index-lobby-wm/img/menu-icon-category-dragon-tiger.png?v=2"
                                                                            />
                                                                            <img
                                                                                alt="category slot image png"
                                                                                className="-hover -icon"
                                                                                width={50}
                                                                                height={50}
                                                                                src="/build/web/igame-index-lobby-wm/img/menu-icon-category-dragon-tiger-hover.png?v=2"
                                                                            />
                                                                            <div className="-menu-text-wrapper">
                                                                                <span className="-text-desktop">ยิงปลา</span>
                                                                                <span className="-text-mobile">ยิงปลา</span>
                                                                            </div>
                                                                        </a>
                                                                    </li>

                                                                </ul>
                                                            </nav>
                                                        </div>
                                                    </div>


                                                    {tabselect !== 99 ?
                                                        this.state.loading ?
                                                            <div className="x-loading -branding">
                                                                <img
                                                                    alt="AE SEXY Image"
                                                                    className="-logo img-fluid"
                                                                    width="400"
                                                                    height="150"
                                                                    src="https://asset.cloudigame.co/build/admin/img/wt_theme/ezl/loading-logo.png"
                                                                />
                                                                <div className="mt-2">กำลังโหลดข้อมูล</div>
                                                            </div>
                                                            :
                                                            <div className="-games-list-container">
                                                                <div className="-games-list-wrapper">
                                                                    <div className="-game-title-wrapper">
                                                                        <div className="-game-title-inner">
                                                                            <h2 className="-game-title h3 ">{tabname.th}</h2>
                                                                        </div>
                                                                    </div>

                                                                    <ul className="navbar-nav -normal-page ">
                                                                        {

                                                                            this.state.tabselect == 17 || this.state.tabselect == 0 ?
                                                                                this.state.categorylist.map((listitem, i) => (
                                                                                    <li className="nav-item -is-lotto-category ">
                                                                                        <a href={() => false}
                                                                                            onClick={(e) => this.redeemlotto(e, listitem._id, listitem.roomid)} >
                                                                                            <div
                                                                                                className="x-game-list-item-macro-in-share js-game-list-toggle -big-with-countdown-flat-dark -cannot-entry -untestable  "
                                                                                                data-status="-cannot-entry -untestable"
                                                                                            >
                                                                                                <div className="-inner-wrapper">
                                                                                                    <div
                                                                                                        className="x-game-badge-component - -big-with-countdown-flat-dark animated fadeInUp"
                                                                                                        data-animatable="fadeInUp"
                                                                                                        data-delay={400}
                                                                                                    >
                                                                                                        <span />
                                                                                                    </div>
                                                                                                    <picture>
                                                                                                        <img
                                                                                                            role="button"
                                                                                                            className={`img-fluid -cover-img ls-is-cached lazyloaded hoverTextCss ${listitem.status === 0 ? "imgBank" : ""}`}
                                                                                                            lazy="loaded"
                                                                                                            src={listitem.image}
                                                                                                        />
                                                                                                    </picture>
                                                                                                    <div className="-overlay">
                                                                                                        <div className="-overlay-inner">
                                                                                                            <div className="-wrapper-container">
                                                                                                                <a
                                                                                                                    href="#"
                                                                                                                    className="js-account-approve-aware -btn -btn-play"
                                                                                                                >
                                                                                                                    <i className="fas fa-play" />
                                                                                                                    <span className="-text-btn">เข้าเล่น</span>
                                                                                                                </a>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                            <div className="x-lotto-title-overlay">
                                                                                                <span className="-game-title">{listitem?.namefix ?? listitem?.name}</span>
                                                                                            </div>
                                                                                            <div className="x-countdown-timer -malay -flat js-timer-state">
                                                                                                <div className="-countdown-timer-outer">
                                                                                                    <div className="-countdown-timer-liner -running " />
                                                                                                    <div className="-countdown-timer-container">
                                                                                                        <div className="-countdown-timer-wrapper -running ">
                                                                                                            <img
                                                                                                                alt="Icon clock"
                                                                                                                className={`img-fluid -icon ${listitem.status === 0 ? "imgBank" : ""}`}
                                                                                                                width={26}
                                                                                                                height={26}
                                                                                                                src="https://asset.cloudigame.co/build/admin/img/wt_theme/ezl/ic-clock.png"
                                                                                                            />
                                                                                                            <i className="far fa-clock d-md-none" style={{ display: "none" }} />
                                                                                                            {/* <span className="-timer">แทงหวย</span> */}
                                                                                                            <span className="-timer" style={{ display: listitem.status === 0 ? "" : "none" }} >ยังไม่เปิด</span>
                                                                                                            <span className="-timer" style={{ display: listitem.status !== 0 ? "" : "none" }} >{this.calculateCountdown(listitem.drawTime, "full")}</span>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                        </a>
                                                                                    </li>


                                                                                ))
                                                                                : this.state.categorylist.map((listitem, i) => (
                                                                                    <li className="nav-item " key={i} id={i}>
                                                                                        <a
                                                                                            onClick={(e) => {
                                                                                                this.checkurl(e, "/listgameall/" + tabname.en + "/" + listitem.partner)
                                                                                            }}
                                                                                            role="button"
                                                                                            rel="nofollow noopener">
                                                                                            <div
                                                                                                className="x-game-list-item-macro-in-share js-game-list-toggle -big -cannot-entry -untestable  "
                                                                                                data-status="-cannot-entry -untestable"
                                                                                            >
                                                                                                <div className="-inner-wrapper">
                                                                                                    <div
                                                                                                        className="x-game-badge-component - -big animated fadeInUp"
                                                                                                        data-animatable="fadeInUp"
                                                                                                        data-delay={400}
                                                                                                    >
                                                                                                        <span />
                                                                                                    </div>
                                                                                                    <picture>

                                                                                                        <img
                                                                                                            alt="wt-ppa-live cover image png"
                                                                                                            className="img-fluid -cover-img lazyloaded"
                                                                                                            width={400}
                                                                                                            height={580}
                                                                                                            src={this.addDefaultSrc(null, listitem.image)}
                                                                                                        />
                                                                                                    </picture>
                                                                                                    <div className="-overlay">
                                                                                                        <div className="-overlay-inner">
                                                                                                            <div className="-wrapper-container">
                                                                                                                <a
                                                                                                                    onClick={(e) => {
                                                                                                                        this.checkurl(e, "/listgameall/" + tabname.en + "/" + listitem.partner)
                                                                                                                    }}
                                                                                                                    role="button"
                                                                                                                    className="js-account-approve-aware -btn -btn-play"
                                                                                                                >
                                                                                                                    <i className="fas fa-play" />
                                                                                                                    <span className="-text-btn">เข้าเล่น</span>
                                                                                                                </a>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                        </a>
                                                                                    </li>

                                                                                ))}
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                        :
                                                        this.state.loading ?
                                                            <div className="x-loading -branding">
                                                                <img
                                                                    alt="AE SEXY Image"
                                                                    className="-logo img-fluid"
                                                                    width="400"
                                                                    height="150"
                                                                    src="https://asset.cloudigame.co/build/admin/img/wt_theme/ezl/loading-logo.png"
                                                                />
                                                                <div className="mt-2">กำลังโหลดข้อมูล</div>
                                                            </div>
                                                            : <div className="-games-list-container">
                                                                <div className="container js-game-container js-game-scroll-container">
                                                                    <div className="-games-list-wrapper">
                                                                        <div className="-game-title-wrapper">
                                                                            <div className="-game-title-inner">
                                                                                <h2 className="-game-title h3 ">{tabnameprovidor.th}</h2>
                                                                            </div>
                                                                            <div className="-game-search-inner">
                                                                                <div >
                                                                                    <div className="input-group x-search-component -category-page-mobile">
                                                                                        <input
                                                                                            type="text"
                                                                                            id="searchKeyword"
                                                                                            name="search"
                                                                                            value={this.state.searchKeyword}
                                                                                            onChange={this.handleInputChange}
                                                                                            className="x-form-control form-control -form-search-input"
                                                                                            placeholder="ค้นหาเกมส์หรือค่ายเกมส์..."
                                                                                        />
                                                                                        <div className="input-group-prepend">
                                                                                            <div className="input-group-text -text-group-wrapper" id="btnGroupAddon">
                                                                                                <button type="button" className="-btn-search" onClick={this.handleSearchClick}>
                                                                                                    <i className="fas fa-search" />
                                                                                                </button>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div className="d-flex align-items-start">
                                                                            <div className="x-menu-collapse-container -v2 -is-sidebar -category-brand">
                                                                                {this.state.providorlist.map((listitem, i) => (
                                                                                    <button
                                                                                        type="button"
                                                                                        onClick={(e) => {
                                                                                            this.checkurl(e, "/listgameall/" + tabnameprovidor.en + "/" + listitem.partner, listitem)
                                                                                        }}
                                                                                        id={listitem.partner}
                                                                                        key={i}
                                                                                        className="btn-block -btn-sidebar "
                                                                                        data-target=".js-game-container"
                                                                                        data-collapse-menu="js-brand"
                                                                                        data-menu-container=".js-menu-container"
                                                                                        data-button-menu={listitem.partner}
                                                                                    >
                                                                                        <div className="-child-collapse-wrapper">
                                                                                            <div className="-img-wrapper">
                                                                                                <picture>
                                                                                                    <img
                                                                                                        alt={listitem.partner}
                                                                                                        className="img-fluid -img-btn ls-is-cached lazyloaded"
                                                                                                        width={40}
                                                                                                        height={40}
                                                                                                        src={listitem.selectimg}
                                                                                                    />
                                                                                                </picture>
                                                                                            </div>
                                                                                            <span className="-menu-text-child">{listitem.description}</span>
                                                                                        </div>
                                                                                    </button>))}
                                                                            </div>
                                                                            <ul className="navbar-nav -slot-provider-page ">
                                                                                {(this.state.filteredList || listitallgame).map((listitem, i) => (
                                                                                    <li className="nav-item">
                                                                                        <a
                                                                                            role='button'
                                                                                            onClick={(e) => this.redeem(e, listitem.gameId, listitem.partner)} >
                                                                                            <div
                                                                                                className="x-game-list-item-macro-in-share js-game-list-toggle -big   "
                                                                                                data-status=""
                                                                                            >
                                                                                                <div className="-inner-wrapper">

                                                                                                    <picture>
                                                                                                        <img
                                                                                                            alt="wt-mpoker cover image png"
                                                                                                            className="img-fluid -cover-img ls-is-cached lazyloaded"
                                                                                                            width={400}
                                                                                                            height={580}
                                                                                                            src={listitem.image}
                                                                                                        />
                                                                                                    </picture>
                                                                                                    <div className="-overlay">
                                                                                                        <div className="-overlay-inner">
                                                                                                            <div className="-wrapper-container">
                                                                                                                <a
                                                                                                                    role='button'
                                                                                                                    onClick={(e) => this.redeem(e, listitem.gameId, listitem.partner)}
                                                                                                                    className="js-account-approve-aware -btn -btn-play"
                                                                                                                    target="_blank"
                                                                                                                >
                                                                                                                    <i className="fas fa-play" />
                                                                                                                    <span className="-text-btn">เข้าเล่น</span>
                                                                                                                </a>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                        </a>
                                                                                    </li>
                                                                                ))}
                                                                            </ul>
                                                                        </div>
                                                                        <div className="js-replace-seo-section-top-container"></div>
                                                                        <div className="js-replace-seo-section-container"></div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                    }

                                                </div>
                                                {/* <div className="-hot-slot-container">
                                                <div className="-inner-heading-wrapper">
                                                    <img src="/build/web/igame-index-lobby-wm/img/ic-nav-menu-popular-slot.png" className="-icon" alt="เกมคาสิโนยอดนิยม เกมสล็อตยอดนิยม" width={55} height={55} />
                                                    <h2 className="-title">สล็อตออนไลน์ ยอดนิยม</h2>
                                                </div>
                                                <nav className="nav-menu" id="navbarProvider">
                                                    <ul className="nav nav-pills">
                                                        {this.state.slotlist.map((listitem, i) => (
                                                            <li key={i} id={listitem.gameid} className="nav-item -game-slot-macro-container -square">
                                                                <a
                                                                    href={"/listgameall/slot/" + listitem.partner}
                                                                    className="nav-link js-account-approve-aware"
                                                                    rel="nofollow noopener"
                                                                >
                                                                    <div className="x-game-list-item-macro js-game-list-toggle -normal " data-status>
                                                                        <div className="-inner-wrapper">
                                                                            <img
                                                                                src={this.addDefaultSrc(null, listitem.image)}
                                                                                width={250} height={250} className="-cover-img lazyload img-fluid" alt="Crown & Anchor | evo-play เว็บคาสิโนออนไลน์ สล็อตออนไลน์ รับเครดิตฟรี" />
                                                                            <div className="-overlay">
                                                                                <div className="-overlay-inner">
                                                                                    <div className="-wrapper-container">
                                                                                        <button href={"/listgameall/slot/" + listitem.partner} className="-btn -btn-play js-account-approve-aware" >
                                                                                            <i className="fas fa-play"></i>
                                                                                            <span className="-text-btn">เข้าเล่น</span>
                                                                                        </button>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div className="-title">{listitem.description}</div>
                                                                    </div>
                                                                </a>
                                                            </li>
                                                        ))}
                                                    </ul>
                                                </nav>
                                            </div> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Lowmenu />


                </section >
                <footer className="x-footer -ezl -anon">
                    <div className="-inner-wrapper ">
                        <div className="container -inner-title-wrapper">
                            <img
                                alt="คาสิโนออนไลน์ แทงหวยออนไลน์ หวยออนไลน์ สล็อตออนไลน์ เว็บพนันออนไลน์"
                                className="img-fluid -logo"
                                width={440}
                                height={104}
                                src={this.state.logoimg}
                            />
                            <p className="-text-sub-title"></p>
                            <p className="-text-sub-title mb-1">
                                <span className="-highlight">Fairbet CASINO th</span> เว็บคาสิโนออนไลน์
                                ครองอันดับในใจคนไทย 5 ปีซ้อน
                            </p>{" "}
                            <p className="-text-sub-title">
                                Fairbet Casino บาคาร่า คาสิโนออนไลน์ ที่ดีที่สุด
                                เพื่อประสบการณ์ที่ดีของผู้เล่นอย่างแท้จริง แบบ Wmbet
                            </p>
                            <p />
                        </div>

                        <div className="container">
                            <div className="-footer-menu">
                                <div className="-block-tag">
                                    <h3 className="-text-title -provider">ผู้ให้บริการคาสิโนออนไลน์</h3>
                                    <div className="row">
                                        <div className="col-12">
                                            <div className="-tags-list">
                                                <a href="#0" className="btn -btn-tag">
                                                    SA Gaming
                                                </a>
                                                <a href="#0" className="btn -btn-tag">
                                                    Fairbet Casino
                                                </a>
                                                <a href="#0" className="btn -btn-tag">
                                                    PragmaticPlay Live
                                                </a>
                                                <a href="#0" className="btn -btn-tag">
                                                    PlayTech Live
                                                </a>
                                                <a href="#0" className="btn -btn-tag">
                                                    Evolution Gaming
                                                </a>
                                                <a href="#0" className="btn -btn-tag">
                                                    AE Sexy
                                                </a>
                                                <a href="#0" className="btn -btn-tag">
                                                    AllBet
                                                </a>
                                                <a href="#0" className="btn -btn-tag">
                                                    Dream Gaming
                                                </a>
                                                <a href="#0" className="btn -btn-tag">
                                                    WE
                                                </a>
                                                <a href="#0" className="btn -btn-tag">
                                                    Asia Gaming
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="-block-tag">
                                    <h3 className="-text-title -tag">TAG</h3>
                                    <div className="row x-footer-seo -ezl">
                                        <div className="col-12 mb-3 -footer-seo-title">
                                            สรุป Fairbet คือ คาสิโนมาแรง ตั้งแต่ปี 2018
                                            ที่พัฒนาและกวาดรางวัลอย่างต่อเนื่อง ปัจจุบันมีเว็บทำตาม wm.bet
                                            มากมาย ทั้ง wm55, wmbet444 หรือ wmcasinogame
                                            ที่เป็นบริษัทลูกต่อกันมา ดังนั้น ถ้าคิดจะเล่น คาสิโนสด livedealer
                                            เสือมังกร ไฮโล sicbo dragontiger ควรเล่นกับเราเท่านั้น
                                        </div>
                                        <div className="col-12 -tags">
                                            <a href="/" className="btn btn-sm">
                                                คาสิโน wm
                                            </a>
                                            <a href="/" className="btn btn-sm">
                                                wm555
                                            </a>
                                            <a href="/" className="btn btn-sm">
                                                wm555 casino
                                            </a>
                                            <a href="/" className="btn btn-sm">
                                                wmbet
                                            </a>
                                            <a href="/" className="btn btn-sm">
                                                wm777
                                            </a>
                                            <a href="/" className="btn btn-sm">
                                                wm99
                                            </a>
                                            <a href="/baccarat-webdirect-wmbet" className="btn btn-sm">
                                                บาคาร่า
                                            </a>
                                            <a href="/wm555-dragon-tiger-wmbet" className="btn btn-sm">
                                                wm555
                                            </a>
                                            <a href="/wm55-casino-experience" className="btn btn-sm">
                                                WM55
                                            </a>
                                            <a href="/wmbet55-baccarat-casino" className="btn btn-sm">
                                                wmbet55
                                            </a>
                                            <a href="/wm444-premium-casino-experience" className="btn btn-sm">
                                                wm444
                                            </a>
                                            <a href="/wmbet444-casino-experience" className="btn btn-sm">
                                                wmbet444
                                            </a>
                                            <a href="/wmcasino-online-direct" className="btn btn-sm">
                                                wmcasino
                                            </a>
                                            <a href="/wm-casino-thai-betting" className="btn btn-sm">
                                                Fairbet CASINO
                                            </a>
                                            <a href="/wm-wmcasino-betting-experience" className="btn btn-sm">
                                                wm
                                            </a>
                                            <a
                                                href="/wm444-Baccarat-website-not-through-an-agent"
                                                className="btn btn-sm"
                                            >
                                                wm444 เว็บบาคาร่าไม่ผ่านเอเย่นต์
                                            </a>
                                            <a
                                                href="/Live-Baccarat-easy-to-apply-automatic-deposit-withdrawal"
                                                className="btn btn-sm"
                                            >
                                                บาคาร่าสด สมัครง่าย
                                            </a>
                                            <a href="/wm444-online-card-service-with" className="btn btn-sm">
                                                wm444
                                            </a>
                                            <a
                                                href="/payout-rate-and-betting-formats-of-WM-CASINO-dice-games"
                                                className="btn btn-sm"
                                            >
                                                Fairbet CASINO
                                            </a>
                                            <a
                                                href="/WMBET-comprehensive-online-casino-platform"
                                                className="btn btn-sm"
                                            >
                                                WMBET
                                            </a>
                                            <a
                                                href="/baccarat-99-casino-game-that-makes-you-rich-Introducing-popular-card-games"
                                                className="btn btn-sm"
                                            >
                                                บาคาร่า99 เกมคาสิโนพารวย
                                            </a>
                                            <a
                                                href="/wm55-a-complete-online-gambling-and-casino-website-system"
                                                className="btn btn-sm"
                                            >
                                                WM55 ระบบเว็บพนัน
                                            </a>
                                            <a
                                                href="/baccarat-6699-source-of-various-types-of-online-gambling-games"
                                                className="btn btn-sm"
                                            >
                                                บาคาร่า6699 แหล่งศูนย์รวม
                                            </a>
                                            <a
                                                href="/baccarat-6688-play-and-get-rich-play-any-game-and-be-great-There-are-many-games-to-choose-from"
                                                className="btn btn-sm"
                                            >
                                                บาคาร่า6688 เล่นแล้วรวย
                                            </a>
                                            <a
                                                href="/baccarat186-gives-away-unlimited-free-credit-bonuses-easy-to-play-and-get-real-money"
                                                className="btn btn-sm"
                                            >
                                                บาคาร่า186 แจกโบนัสเครดิตฟรีไม่อั้น
                                            </a>
                                            <a
                                                href="/Investing-with-baccarat-365-only-guarantees-financial-safety"
                                                className="btn btn-sm"
                                            >
                                                ลงทุนกับ บาคาร่า365 มีแต่ได้
                                            </a>
                                            <a
                                                href="/wm444-the-most-popular-online-gambling-website-on-the-charts-It-has-won-the-hearts-of-gamblers-for-a-long-time"
                                                className="btn btn-sm"
                                            >
                                                wm444 เว็บพนันออนไลน์ยอดฮิตติดชาร์ต
                                            </a>
                                            <a
                                                href="/baccarat-168-an-easy-way-to-make-a-profit-the-number-1-choice-of-gamblers"
                                                className="btn btn-sm"
                                            >
                                                บาคาร่า168 ช่องทางการทำกำไรง่าย ๆ
                                            </a>
                                            <a
                                                href="/play-online-casino-at-baccarat888-a-game-that-makes-lots-of-money"
                                                className="btn btn-sm"
                                            >
                                                เล่นคาสิโนออนไลน์ที่ บาคาร่า888
                                            </a>
                                            <a
                                                href="/wm-gives-out-a-special-promotion-deposit-100-get-150-plus-many-more-free-bonuses"
                                                className="btn btn-sm"
                                            >
                                                Fairbet แจกโปรโมชั่นสุดพิเศษ
                                            </a>
                                            <a
                                                href="/point-out-the-easy-way-to-get-rich-just-play-wm-casino-confident-that-it-s-100-safe"
                                                className="btn btn-sm"
                                            >
                                                ชี้ทางรวยง่าย ๆ เพียงเข้าเล่น Fairbet casino
                                            </a>
                                            <a
                                                href="/easy-to-play-pay-for-real-must-be-baccarat-777-one-website-complete-with-all-famous-brands"
                                                className="btn btn-sm"
                                            >
                                                เล่นง่ายจ่ายจริงต้อง บาคาร่า777
                                            </a>
                                            <a
                                                href="/wm666-is-ready-to-provide-fun-beyond-imagination-There-are-many-popular-games"
                                                className="btn btn-sm"
                                            >
                                                wm666 พร้อมมอบความสนุก
                                            </a>
                                            <a
                                                href="/play-baccarat-with-wm789-the-number-1-online-casino-direct-website-not-through-agents"
                                                className="btn btn-sm"
                                            >
                                                ปั่นบาคาร่ากับ wm789
                                            </a>
                                            <a
                                                href="/betting-like-no-other-baccarat-1688-easy-to-make-profit"
                                                className="btn btn-sm"
                                            >
                                                การเดิมพันไม่เหมือนใคร บาคาร่า1688
                                            </a>
                                            <a
                                                href="/wm777-online-casino-direct-website-stable-easy-to-make-profit-only-here"
                                                className="btn btn-sm"
                                            >
                                                wm777 คาสิโนออนไลน์เว็บตรง
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="-terms-wrapper">
                            <a
                                href="/term-and-condition"
                                target="_blank"
                                className="-link"
                                rel="nofollow noopener"
                            >
                                Term and condition
                            </a>
                        </div>
                    </div>
                    <div className="text-center -copy-right-container">
                        <p className="mb-0 -copy-right-text">
                            Copyright © 2025 Fairbet CASINO. All Rights Reserved.
                        </p>
                    </div>
                </footer>
                <div
                    className="x-modal modal -v2 -modal-full-page"
                    id="websiteMenuModal"
                    role="dialog"
                    data-loading-container=".js-modal-content"
                    data-ajax-modal-always-reload="true"
                    tabIndex={-1}
                    style={{ display: "none" }}
                    aria-hidden="true"
                >
                    <div
                        className="modal-dialog -modal-size -v2 modal-dialog-centered modal-dialog-scrollable "
                        role="document"
                    >
                        <div className="modal-content -modal-content">
                            <button
                                type="button"
                                className="close f-1 "
                                data-dismiss="modal"
                                aria-label="Close"
                            >
                                <i className="fas fa-times" />
                            </button>
                            <div className="modal-header -modal-header">
                                <h3 className="x-title-modal d-inline-block m-auto">
                                    <span />{" "}
                                </h3>
                            </div>
                            <div className="modal-body -modal-body">
                                <div className="x-website-menu-modal-body">
                                    <a href="/" className="nav-link -btn-logo">
                                        <img
                                            alt="บาคาร่าออนไลน์ สล็อตออนไลน์ อันดับหนึ่งในประเทศไทย"
                                            className="img-fluid -img ls-is-cached lazyloaded"
                                            width={400}
                                            height={150}
                                            src={this.state.logoimg}
                                        />
                                    </a>

                                    <ul className="nav x-website-menu-entry-list -as-column">
                                        <li className="nav-item -nav-item">
                                            <a className="nav-link -nav-link" onClick={(e) => {
                                                this.checkurl(e, "/dailycheckin")
                                            }}>
                                                <img
                                                    alt="เช็คอินประจำวัน เช็คทุกวันรับมากกว่า"
                                                    className="img-fluid -img lazyloaded"
                                                    width={50}
                                                    height={50}
                                                    data-src="/build/web/igame-index-lobby-wm/img/ic-website-menu-daily-check-in.png?v=2"
                                                    src="/build/web/igame-index-lobby-wm/img/ic-website-menu-daily-check-in.png?v=2"
                                                />
                                                <span className="-text">เช็คอิน</span>
                                            </a>
                                        </li>
                                        <li className="nav-item -nav-item" role='button'>
                                            <a className="nav-link -nav-link" role='button' style={{ cursor: "pointer" }} onClick={(e) => {
                                                this.checkurl(e, "/luckyfortune")
                                            }}>
                                                <img
                                                    alt="บาคาร่าออนไลน์ สล็อตออนไลน์ อันดับหนึ่งในประเทศไทย"
                                                    className="img-fluid -img ls-is-cached lazyloaded"
                                                    width={50}
                                                    height={50}
                                                    data-src="https://asset.cloudigame.co/build/admin/img/wt_theme/ezl/ic-website-menu-wheel.png"
                                                    src="https://asset.cloudigame.co/build/admin/img/wt_theme/ezl/ic-website-menu-wheel.png"
                                                />
                                                <span className="-text">กงล้อพารวย</span>
                                            </a>
                                        </li>
                                        <li className="nav-item -nav-item">
                                            <a
                                                className="nav-link -nav-link"
                                                href="/ranking/%E0%B8%9A%E0%B8%AD%E0%B8%A3%E0%B9%8C%E0%B8%94%E0%B9%80%E0%B8%8B%E0%B8%B5%E0%B8%A2%E0%B8%99"
                                            >
                                                <img
                                                    alt="บาคาร่าออนไลน์ สล็อตออนไลน์ อันดับหนึ่งในประเทศไทย"
                                                    className="img-fluid -img ls-is-cached lazyloaded"
                                                    width={50}
                                                    height={50}
                                                    data-src="https://asset.cloudigame.co/build/admin/img/wt_theme/ezl/ic-website-menu-ranking.png"
                                                    src="https://asset.cloudigame.co/build/admin/img/wt_theme/ezl/ic-website-menu-ranking.png"
                                                />
                                                <span className="-text">จัดอันดับ</span>
                                            </a>
                                        </li>
                                        <li className="nav-item -nav-item">
                                            <a
                                                className="nav-link -nav-link"
                                                href="#0"
                                                data-toggle="modal"
                                                data-target="#loginModal"
                                                data-dismiss="modal"
                                                target="_blank"
                                                rel="noopener nofollow"
                                            >
                                                <img
                                                    alt="บาคาร่าออนไลน์ สล็อตออนไลน์ อันดับหนึ่งในประเทศไทย"
                                                    className="img-fluid -img ls-is-cached lazyloaded"
                                                    width={50}
                                                    height={50}
                                                    data-src="https://asset.cloudigame.co/build/admin/img/wt_theme/ezl/ic-website-menu-sood.png"
                                                    src="https://asset.cloudigame.co/build/admin/img/wt_theme/ezl/ic-website-menu-sood.png"
                                                />
                                                <span className="-text">กลยุทธ์</span>
                                            </a>
                                        </li>
                                        <li className="nav-item -nav-item">
                                            <a className="nav-link -nav-link" href="/reviews">
                                                <img
                                                    alt="บาคาร่าออนไลน์ สล็อตออนไลน์ อันดับหนึ่งในประเทศไทย"
                                                    className="img-fluid -img ls-is-cached lazyloaded"
                                                    width={50}
                                                    height={50}
                                                    data-src="https://asset.cloudigame.co/build/admin/img/wt_theme/ezl/ic-website-menu-review.png"
                                                    src="https://asset.cloudigame.co/build/admin/img/wt_theme/ezl/ic-website-menu-review.png"
                                                />
                                                <span className="-text">รีวิว</span>
                                            </a>
                                        </li>
                                        <li className="nav-item -nav-item">
                                            <a className="nav-link -nav-link"
                                                role='button'
                                                onClick={(e) => {
                                                    this.checkurl(e, "/promotion")
                                                }}
                                            >
                                                <img
                                                    alt="บาคาร่าออนไลน์ สล็อตออนไลน์ อันดับหนึ่งในประเทศไทย"
                                                    className="img-fluid -img lazyloaded"
                                                    width={50}
                                                    height={50}
                                                    data-src="/build/web/igame-index-lobby-wm/img/ic-website-menu-promotion.png?v=2"
                                                    src="/build/web/igame-index-lobby-wm/img/ic-website-menu-promotion.png?v=2"
                                                />
                                                <span className="-text">โปรโมชั่น</span>
                                            </a>
                                        </li>
                                        <li className="nav-item -nav-item">
                                            <a className="nav-link -nav-link" href="/event">
                                                <img
                                                    alt="บาคาร่าออนไลน์ สล็อตออนไลน์ อันดับหนึ่งในประเทศไทย"
                                                    className="img-fluid -img lazyloaded"
                                                    width={50}
                                                    height={50}
                                                    data-src="/build/web/igame-index-lobby-wm/img/ic-website-menu-event.png?v=2"
                                                    src="/build/web/igame-index-lobby-wm/img/ic-website-menu-event.png?v=2"
                                                />
                                                <span className="-text">สิทธิพิเศษ</span>
                                            </a>
                                        </li>
                                        <li className="nav-item -nav-item">
                                            <a className="nav-link -nav-link" href="/blogs">
                                                <img
                                                    alt="บาคาร่าออนไลน์ สล็อตออนไลน์ อันดับหนึ่งในประเทศไทย"
                                                    className="img-fluid -img ls-is-cached lazyloaded"
                                                    width={50}
                                                    height={50}
                                                    data-src="https://asset.cloudigame.co/build/admin/img/wt_theme/ezl/ic-website-menu-blog.png"
                                                    src="https://asset.cloudigame.co/build/admin/img/wt_theme/ezl/ic-website-menu-blog.png"
                                                />
                                                <span className="-text">บทความ</span>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    className="x-modal modal -v2 show"
                    id="joinPromotionModalMobile"
                    tabIndex={-1}
                    role="dialog"
                    data-container="#joinPromotionModalMobile"
                    aria-modal="true"
                >
                    <div
                        className="modal-dialog -modal-size  modal-dialog-centered modal-dialog-scrollable -modal-mobile -no-fixed-button -no-padding-x"
                        role="document"
                    >
                        <div className="modal-content -modal-content">
                            <button
                                type="button"
                                className="close f-1 "
                                data-dismiss="modal"
                                aria-label="Close"
                            >
                                <i className="fas fa-times" />
                            </button>
                            <div className="modal-header -modal-header">
                                <div className="x-modal-mobile-header">
                                    <div className="-header-mobile-container">
                                        <h3 className="x-title-modal mx-auto text-center d-inline-block">
                                            การเข้าร่วมโปรโมชั่น
                                        </h3>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-body -modal-body">
                                <div className="-outer-history-wrapper">
                                    <div className="x-bill-history-container">
                                        <div
                                            className="wg-container wg-container__wg_bill_history wg--loaded"
                                            data-widget-name="wg_bill_history"
                                            data-widget-options='{"script_path":null,"style_path":null,"image_path":null,"visibility":"away","visibility_offset":"100%","render_url":"\/_widget","render_method":"GET","attr_style":null,"attr_class":null,"scroll_position":"current","options":{},"callback":{},"mode":"clear","mask_mode":"over","mask_style":"wg-loading","limit":20,"page":1,"template":"@Base\/Widget\/billHistory.html.twig","name":"wg_bill_history"}'
                                            data-widget-user-options='{"page":1}'
                                        >
                                            <div className="wg-content" style={{ display: (proderedeemlist.length === 0) ? "" : "none" }}>
                                                <div className="-no-result-wrapper mt-3">
                                                    <div className="-heading-title">
                                                        <i className="fas fa-times-circle -icon" />
                                                        <div className="-title">ไม่พบข้อมูล</div>
                                                        <div className="-sub-title">คุณยังไม่มีข้อมูลการทำรายการค่ะ</div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="wg-content" style={{ display: (proderedeemlist.length === 0) ? "none" : "" }}>
                                                <table className="table table-borderless table-striped">
                                                    <tbody>
                                                        {proderedeemlist.map((listitem, i) => (
                                                            <tr key={i} id={i}>
                                                                <td className="-description-body-wrapper">
                                                                    <div className="-title-wrapper">
                                                                        <span className="-title">{listitem.proname}</span>
                                                                        <span style={{ display: (listitem.status === 1) ? "" : "none", margin: "5px" }}>
                                                                            <a href="#0"
                                                                                onClick={(e) => {
                                                                                    this.cancelredeempromotion(e, listitem)
                                                                                }}
                                                                                className="-link-change-password" ><u>ยกเลิก</u></a>
                                                                        </span>
                                                                    </div>
                                                                    <div className="-state-wrapper" style={{ display: (listitem.status === 1) ? "" : "none" }}>
                                                                        <span className="-state-text">สถานะ : </span>
                                                                        <i className="fas fa-spinner fa-spin"></i>
                                                                        <span className="-state-title">รอดำเนินการ</span>
                                                                        <span className="-state-title -short">รอดำเนินการ  </span>
                                                                    </div>
                                                                    <div className="-state-wrapper" style={{ display: (listitem.status === 4) ? "" : "none" }}>
                                                                        <span className="-state-text">สถานะ : </span>
                                                                        <img
                                                                            src="https://asset.cloudigame.co/build/admin/img/wt_theme/popular_3/ic_fail.png"
                                                                            className="-ic"
                                                                            alt=""
                                                                        />
                                                                        <span className="-state-title">ยกเลิก (ยกเลิกโดยผู้เล่น)</span>
                                                                        <span className="-state-title -short">ยกเลิก (โดยผู้เล่น)</span>
                                                                    </div>
                                                                    <div className="-state-wrapper" style={{ display: (listitem.status === 3) ? "" : "none" }}>
                                                                        <span className="-state-text">สถานะ : </span>
                                                                        <img
                                                                            src="https://asset.cloudigame.co/build/admin/img/wt_theme/popular_3/ic_fail.png"
                                                                            className="-ic"
                                                                            alt=""
                                                                        />
                                                                        <span className="-state-title">ไม่สำเร็จ (โดยระบบ)</span>
                                                                        <span className="-state-title -short">ไม่สำเร็จ (โดยระบบ)</span>
                                                                    </div>
                                                                    <div className="-state-wrapper" style={{ display: (listitem.status === 2) ? "" : "none" }}>
                                                                        <span className="-state-text">สถานะ : </span>
                                                                        <img
                                                                            src="https://asset.cloudigame.co/build/admin/img/wt_theme/popular_3/ic_success.png"
                                                                            className="-ic"
                                                                            alt=""
                                                                        />
                                                                        <span className="-state-title">สำเร็จ</span>
                                                                        <span className="-state-title -short">สำเร็จ</span>
                                                                    </div>
                                                                </td>
                                                                <td className="-transaction-body-wrapper">
                                                                    <div className="-amount -deposit">{Number(listitem.credit || 0).toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')} บาท</div>
                                                                    <div className="-datetime">{moment(listitem.datecreate).format('DD/MM/YY') + " - " + moment(listitem.datecreate).format('HH:mm') + " น."} </div>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    className="x-modal modal -v2 show"
                    id="providerUserModalMobile"
                    tabIndex={-1}
                    role="dialog"
                    data-container="#providerUserModalMobile"
                    aria-modal="true"
                >
                    <div
                        className="modal-dialog -modal-size  modal-dialog-centered modal-dialog-scrollable -modal-mobile -no-fixed-button"
                        role="document"
                    >
                        <div className="modal-content -modal-content">
                            <button
                                type="button"
                                className="close f-1 "
                                data-dismiss="modal"
                                aria-label="Close"
                            >
                                <i className="fas fa-times" />
                            </button>
                            <div className="modal-header -modal-header">
                                <div className="x-modal-mobile-header">
                                    <div className="-header-mobile-container">
                                        <h3 className="x-title-modal mx-auto text-center d-inline-block">
                                            ชวนเพื่อน
                                        </h3>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-body -modal-body">
                                <div id="accountProviderUser" className="x-account-provider ">
                                    <div
                                        data-animatable="fadeInModal"
                                        className="-account-provider-container animated fadeInModal"
                                    >
                                        <div className="-group-trace-wrapper">
                                            <div className="x-profile-group-trace-condition ">
                                                <div className="-card-condition-wrapper">
                                                    <div className="-card-condition-heading">
                                                        <span className="-title">
                                                            รับลิงค์ชวนเพื่อน
                                                        </span>
                                                    </div>
                                                    <div className="-card-condition-description">
                                                        กดที่ลิงค์ <span className="-highlight">
                                                            <a href={() => false} style={{ cursor: "pointer" }} onClick={() => this.copyCode()} className="-copy-wrapper js-copy-to-clipboard" data-container="shareAccountProfileBankInfo" data-message="คัดลอกแล้ว!" >
                                                                {linkaff}
                                                            </a>
                                                        </span>
                                                    </div>
                                                    <p className="-note">รายชื่อที่มี
                                                        <img src="/build/web/igame-index-lobby-wm/img/ic-coin.png"
                                                            className="-ic"
                                                            style={{ marginLeft: "5px" }}
                                                            width={"20px"}
                                                            alt=""
                                                        />  ครบเงื่อนใขการเติมเงินขั่นต่ำ 100 บาทแล้ว </p>
                                                    <span className="-title">
                                                        คุณได้รับเครดิตชวนเพื่อน<span className="-title" style={{ color: "#d9ad70" }}  > {tblprofile.AffiliateCash}  </span> บาท (คำนวณทุกวันอาทิตย์ เวลา 00.00น.)
                                                    </span>
                                                    {/* <span className="-title">
                            คุณได้รับเครดิตยอดเสีย<span className="-title" style={{ color: "#d9ad70" }}  > {cashoutSet != null ? cashoutSet.percent : "0"}  </span> บาท (คำนวณทุกวันอาทิตย์ เวลา 00.00น.)
                          </span> */}

                                                </div>
                                                <span className="-title">
                                                    คุณได้เปอเซนต์  <span className="-title" style={{ color: "#d9ad70" }}  >{tblprofile.AffPercent}%</span> จากยอดเสีย
                                                </span>
                                                <div className="-outer-history-wrapper" style={{ marginTop: "10px" }} >
                                                    <div className="x-bill-history-container">
                                                        <div
                                                            className="wg-container wg-container__wg_bill_history wg--loaded"
                                                            data-widget-name="wg_bill_history"
                                                            data-widget-options='{"script_path":null,"style_path":null,"image_path":null,"visibility":"away","visibility_offset":"100%","render_url":"\/_widget","render_method":"GET","attr_style":null,"attr_class":null,"scroll_position":"current","options":{},"callback":{},"mode":"clear","mask_mode":"over","mask_style":"wg-loading","limit":20,"page":1,"template":"@Base\/Widget\/billHistory.html.twig","name":"wg_bill_history"}'
                                                            data-widget-user-options='{"page":1}'
                                                        >
                                                            <div className="wg-content" style={{ display: (this.state.useradvice.length === 0) ? "" : "none" }}>
                                                                <div className="-no-result-wrapper mt-3">
                                                                    <div className="-heading-title">
                                                                        <i className="fas fa-times-circle -icon" />
                                                                        <div className="-title">ไม่พบข้อมูล</div>
                                                                        <div className="-sub-title" style={{ color: "black" }}>คุณยังไม่มีข้อมูลการชวนเพื่อนค่ะ</div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="wg-content" style={{ display: (this.state.useradvice.length === 0) ? "none" : "" }}>
                                                                <table className="table table-borderless table-striped">
                                                                    <tbody>
                                                                        {this.state.useradvice.map((listitem, i) => (
                                                                            <tr key={i} id={listitem.tid}>
                                                                                <td className="-description-body-wrapper">
                                                                                    <div className="-title-wrapper">

                                                                                        {i + 1 + "."} <span className="-title" style={{ marginLeft: "0px" }}> {listitem.playerid}

                                                                                            {(listitem.checked !== 1) ? "" : <img src="/build/web/igame-index-lobby-wm/img/ic-coin.png"
                                                                                                className="-ic"
                                                                                                style={{ marginRight: "5px" }}
                                                                                                width={"20px"}
                                                                                                alt=""
                                                                                            />}
                                                                                        </span>
                                                                                    </div>
                                                                                </td>
                                                                                <td className="-transaction-body-wrapper">
                                                                                    <div className="-datetime">{moment(listitem.DateCreate).format('DD/MM/YY') + " - " + moment(listitem.DateCreate).format('HH:mm') + " น."} </div>
                                                                                </td>
                                                                            </tr>
                                                                        ))}
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <div className="x-modal modal " id="registerModal"
                    tabIndex={-1}
                    role="dialog"
                    aria-hidden="true"
                    data-container="#registerModal"
                >
                    <div
                        className="modal-dialog -modal-size modal-dialog-centered modal-dialog-scrollable "
                        role="document"
                    >
                        <div className="modal-content -modal-content">
                            <button
                                type="button"
                                className="close f-1 -in-tab"
                                data-dismiss="modal"
                                aria-label="Close"
                            >
                                <i className="fas fa-times" />
                            </button>
                            <div className="x-modal-account-security-tabs">
                                <button
                                    type="button"
                                    // href="/register"
                                    className="-btn -register js-modal-account-security-tab-button -active"
                                    data-modal-target="#registerModal"
                                >
                                    สมัครสมาชิก
                                </button>
                                <button
                                    type="button"
                                    data-toggle="modal"
                                    className="-btn -login js-modal-account-security-tab-button "
                                    data-modal-target="#loginModal"
                                >
                                    เข้าสู่ระบบ
                                </button>
                            </div>
                            <div className="modal-body -modal-body">
                                <div className="x-form-register -register mt-0">
                                    <div className="row -animatable-container">
                                        <div className="col order-1 text-center pr-lg-0 mx-auto js-slide-term-and-condition-content x-slide-left-content x-slide-left-content-term -hide">
                                            <h3 className="x-title-modal mx-auto text-center ">
                                                Term and condition
                                            </h3>
                                            <div className="-fake-inner-body">
                                                <div className="-term-and-condition-content js-term-and-condition">
                                                    <div className="x-term-and-condition">
                                                        <div className="-block-content-term-and-condition -register-modal">
                                                            <div className="-inner-wrapper">
                                                                <h1 className="f-4">ข้อตกลงในการใช้งาน</h1>
                                                                <ul className="list-unstyled -detail">
                                                                    <li>
                                                                        สมาชิกต้องกรอกข้อมูลจริงให้สมบูรณ์และสามารถติดต่อได้
                                                                        เพื่อเปิดบัญชีFairbetCasino
                                                                        (บริษัทจำกัดคนละบัญชีเท่านั้น)
                                                                    </li>
                                                                    <li>
                                                                        ชื่อ-นามสกุล กับ
                                                                        ชื่อในข้อมูลธนาคารที่ให้สำหรับการฝาก/ถอน
                                                                        ต้องตรงกัน
                                                                        (บริษัทอนุมัติเฉพาะรายการที่ข้อมูลตรงกับข้อมูลสมาชิกเท่านั้น
                                                                        หากมีข้อผิดพลาดจากสมาชิกบริษัทจะไม่รับผิดชอบใดๆ)
                                                                    </li>
                                                                    <li>
                                                                        ทุกข้อเสนอจำกัดสำหรับหนึ่ง บุคคล, ชื่อ หรือ สกุล ,
                                                                        ที่อยุ่ , อีเมล์ , เบอร์โทรศัพท์, บัญชีธนาคาร , IP
                                                                        แอดเดรส เดียวเท่านั้น (บริษัทมีระบบตรวจสอบ
                                                                        การใช้ข้อมูล การเข้าใช้ ที่ซ้ำซ้อนกัน)
                                                                    </li>
                                                                    <li>
                                                                        สมาชิกที่ต้องการเปลี่ยนแปลงข้อมูล
                                                                        จะต้องไม่ติดกิจกรรมใดๆ และเคยฝากเงินแล้วเท่านั้น
                                                                    </li>
                                                                    <li>
                                                                        สมาชิกต้องวางเดิมพัน จึงจะสามารถถอนเงินได้ (
                                                                        ไม่สามารถฝาก และถอนเงินทันทีโดยที่ไม่วางเดิมพัน )
                                                                    </li>
                                                                    <li>
                                                                        ในกรณีตรวจพบว่าสมาชิก ฝาก/ถอน ผิดปกติเพื่อก่อกวน
                                                                        เอาเปรียบบริษัท หรือคาดว่าเป็นมิจฉาชีพ
                                                                        ทีมงานขอสงวนสิทธิ์ในการระงับยูสเซอร์ตรวจสอบ
                                                                        และตัดสิน
                                                                    </li>
                                                                    <li>
                                                                        ในกรณีตรวจพบว่าท่านสมาชิกมีการละเมิดข้อกำหนดเงื่อนไข
                                                                        หรือมีการกระทำผิดกติกาในการเข้าร่วมโปรโมชั่นเพื่อให้ได้มาซึ่งเครดิต,
                                                                        โบนัสพิเศษ, เทิร์นโอเวอร์ ในทางทุจจริต
                                                                        ทางเราขอสงวนสิทธิ์ในการระงับใช้บัญชีนั้นๆ ทันที
                                                                        และเครดิตที่ได้มาไม่สามารถถอนได้
                                                                    </li>
                                                                    <li>
                                                                        บริษัทขอสงวนสิทธิ์ในการแก้ไขหรือ
                                                                        ยกเลิกโปรโมชั่นสำหรับท่านสมาชิก
                                                                        ได้โดยอัพเดทหน้าเว็บไซต์
                                                                        และไม่ต้องแจ้งให้ทราบล่วงหน้า
                                                                    </li>
                                                                    <li>
                                                                        บริษัทขอสงวนสิทธิ์โดยใช้ดุลยพินิจแต่เพียงผู้เดียวในการทำให้เงินรางวัลเป็นโมฆะและริบยอดเงินใดก็ตามในบัญชีการเดิมพันของคุณ
                                                                        ในการสิ้นสุดข้อตกลงและ/หรือระงับการให้บริการ/ปิดการใช้งานบัญชี
                                                                    </li>
                                                                    <li>
                                                                        หากเราระบุได้ว่าคุณมีบัญชีกับเรามากกว่าหนึ่งบัญชี
                                                                    </li>
                                                                    <li>หากคุณกำลังละเมิดข้อกำหนดใดๆ ของข้อตกลงนี้</li>
                                                                    <li>
                                                                        หาก
                                                                        บริษัททราบว่าคุณได้วางเดิมพันกับเว็บไซต์วางเดิมพันออนไลน์หรือใช้บริการใดก็ตามและถูกสงสัยว่าได้ฉ้อโกง
                                                                        สมรู้ร่วมคิด
                                                                        หรือกิจกรรมที่ไม่เหมาะสมหรือมิชอบด้วยกฎหมาย
                                                                    </li>
                                                                    <li>
                                                                        หาก
                                                                        คุณไม่สามารถจัดเตรียมข้อมูลการยืนยันตัวตนตามที่ร้องขอ
                                                                    </li>
                                                                    <li>
                                                                        หากบริษัท ไม่สามารถทำการตรวจสอบ
                                                                        หรือข้อมูลที่ท่านให้มานั้นไม่ถูกต้อง, ข้อมูลเท็จ
                                                                        หรือข้อมูลไม่สมบูรณ์
                                                                        ทางเราขอสงวนสิทธิ์ที่จะทำการปฏิเสธโดยไม่มีการแจ้งให้ทราบล่วงหน้า
                                                                        หรือไม่รับผิดชอบใดๆในบัญชีของท่าน
                                                                    </li>
                                                                    <li>
                                                                        หาก
                                                                        คุณฝากเงินด้วยเงินที่ได้มาด้วยการทุจริตหรือมิชอบด้วยกฎหมายหรือได้มาอย่างไม่ถูกต้อง
                                                                    </li>
                                                                    <li>
                                                                        หากบริษัท
                                                                        สงสัยว่าบัญชีของท่านมีความเกี่ยวข้องกับการฉ้อโกงหรือการกระทำที่เป็นทุจริต
                                                                    </li>
                                                                    <li>
                                                                        หากบริษัท สงสัยว่าท่าน
                                                                        หรือสมรู้ร่วมคิดกับบุคคลอื่นๆ
                                                                        เพื่อที่จะทำการอย่างใดอย่างหนึ่ง
                                                                        หรือพยายามฉ้อโกงทางเว็บ
                                                                    </li>
                                                                    <li>
                                                                        หากบริษัท ได้รับแจ้งว่าท่านได้มีการปลอม
                                                                        หรือแทรกแซง
                                                                        หรือดำเนินการขั้นตอนเพื่อทำการปกปิดหรือแทรกแซงในทางใด
                                                                        ๆ ในเรื่องของ IP
                                                                        ในอุปกรณ์ที่ใช้ในการเข้าถึงเว็บไซต์ เช่น Virtual
                                                                        Private Network "VPN"
                                                                    </li>
                                                                    <li>
                                                                        หากคุณได้มีการใช้โปรแกรม VPN หรือวิธีการใดๆ
                                                                        ที่พยายามจะปลอมแปลง หรือซ่อนตัวตนที่แท้จริงของท่าน
                                                                        หรือการตรวจสอบตามขอบเขตอำนาจด้านการพนัน
                                                                    </li>
                                                                </ul>
                                                                <b>
                                                                    **บริษัทFairbetCasino
                                                                    เป็นผู้ตัดสินเพียงผู้เดียวและคำตัดสินใจถือเป็นที่สิ้นสุด**
                                                                </b>
                                                            </div>
                                                        </div>
                                                        <div className="text-center d-lg-none">
                                                            <a
                                                                href="#close-term-and-condition"
                                                                className="js-get-term-and-condition btn  btn-primary my-0 my-lg-3"
                                                            >
                                                                <span>ย้อนกลับ</span>
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div
                                            data-animatable="fadeInRegister"
                                            data-offset={0}
                                            className="col order-lg-2 order-0 -form  fadeInRegister"
                                        >
                                            <div className="x-modal-separator-container ">
                                                <div className="-top " style={{ display: this.state.stateregis === 1 ? "" : "none" }}>
                                                    <h3 className="x-title-modal mx-auto text-center ">
                                                        กรอกเบอร์โทรศัพท์
                                                    </h3>
                                                    <div className="-fake-inner-body">
                                                        <div className="x-step-register -v2">
                                                            <div className="px-0 m-auto -container-wrapper">
                                                                <div className={"-step-box-outer" + (this.state.stateregis !== 1 ? "" : " step-active")}></div>
                                                                <div className={"-step-box-outer" + (this.state.stateregis !== 2 ? "" : " step-active")}></div>
                                                                <div className={"-step-box-outer" + (this.state.stateregis !== 2 ? "" : " step-active")}></div>
                                                                <div className={"-step-box-outer" + (this.state.stateregis !== 3 ? "" : " step-active")}></div>
                                                            </div>
                                                        </div>
                                                        <div >
                                                            <div className="-x-input-icon mb-3 text-center">
                                                                <img
                                                                    src="/build/web/igame-index-lobby-wm/img/ic-input-phone.png"
                                                                    className="-icon"
                                                                    alt="SA Casino phone icon"
                                                                    width={10}
                                                                    height={14}
                                                                />
                                                                <input
                                                                    onChange={this.onChangex}
                                                                    type="text"
                                                                    id="phoneNumber"
                                                                    name="phoneNumber"
                                                                    required="required"
                                                                    pattern="[0-9]*"
                                                                    className="x-form-control form-control"
                                                                    placeholder="กรุณากรอกเบอร์โทรศัพท์"
                                                                    autoFocus="autoFocus"
                                                                    autoComplete="on"
                                                                    inputMode="text"
                                                                />
                                                                <div id="checkotpforgetphonenormal" className="invalid-feedback ">
                                                                    <ul className="list-unstyled mb-0"><li>{stateopterror}</li></ul>
                                                                </div>
                                                            </div>
                                                            <h3 className="x-title-modal mx-auto text-center " style={{ marginBottom: "15px" }}>
                                                                ผู้แนะนำ(ไม่ไส่ก็ได้)
                                                            </h3>
                                                            <div className="-x-input-icon mb-3 text-center">
                                                                <img
                                                                    src="/build/web/igame-index-lobby-wm/img/ic-user-v2.png"
                                                                    className="-icon"
                                                                    alt="SA Casino phone icon"
                                                                    width={10}
                                                                    height={14}
                                                                />
                                                                <input
                                                                    onChange={this.onChangex}
                                                                    readOnly={true}
                                                                    style={{ color: "black", background: "transparent" }}
                                                                    type="text"
                                                                    id="userrecomend"
                                                                    name="userrecomend"
                                                                    required="required"
                                                                    value={userrecomend}
                                                                    className="x-form-control form-control"
                                                                    placeholder="ผู้แนะนำ"
                                                                    autoFocus="autoFocus"
                                                                    autoComplete="on"
                                                                    inputMode="text"
                                                                />
                                                            </div>
                                                            <div className="text-center">
                                                                <button
                                                                    onClick={(e) => {
                                                                        this.nextstep(e, 1)
                                                                    }}
                                                                    type="submitx"
                                                                    className="btn   btn-primary mt-lg-3 mt-0"
                                                                    disabled=""
                                                                >
                                                                    ต่อไป
                                                                </button>
                                                            </div>
                                                            <input
                                                                type="hidden"
                                                                id="request_otp__token"
                                                                name="request_otp[_token]"
                                                                defaultValue="ds26nEjb1GacmW8racC7ScvGiCgTEnPl5xKWBzZyMWc"
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="-top " style={{ display: this.state.stateregis === 5 ? "" : "none" }}>
                                                    <h3 className="x-title-modal mx-auto text-center ">
                                                        ยืนยัน OTP
                                                    </h3>
                                                    <div className="-img-container ">
                                                        {/* <picture>
                              <source
                                type="image/webp"
                                srcSet="https://sacasino.co/build/web/ezc-sa-casino/img/register-icon-otp-v2.webp"
                              />
                              <source
                                type="image/png?v=5"
                                srcSet="https://sacasino.co/build/web/ezc-sa-casino/img/register-icon-otp-v2.webp"
                              />
                              <img
                                alt="กรอกรหัส OTP เพื่อยืนยันตัวตน"
                                className="img-fluid -ic-otp"
                                width={150}
                                height={150}
                                src="https://sacasino.co/build/web/ezc-sa-casino/img/register-icon-otp-v2.webp"
                              />
                            </picture> */}
                                                    </div>

                                                    <div className="-fake-inner-body">
                                                        <div className="x-step-register -v2">
                                                            <div className="px-0 m-auto -container-wrapper">
                                                                <div className={"-step-box-outer" + (this.state.stateregis !== 5 ? "" : " step-active")}></div>
                                                                <div className={"-step-box-outer" + (this.state.stateregis !== 5 ? "" : " step-active")}></div>
                                                                <div className={"-step-box-outer" + (this.state.stateregis !== 3 ? "" : " step-active")}></div>
                                                                <div className={"-step-box-outer" + (this.state.stateregis !== 3 ? "" : " step-active")}></div>
                                                            </div>
                                                        </div>
                                                        <div >
                                                            <div className="-x-input-icon mb-3 text-center">
                                                                <img
                                                                    src="/build/web/igame-index-lobby-wm/img/ic-input-phone.png"
                                                                    className="-icon"
                                                                    alt="SA Casino phone icon"
                                                                    width={10}
                                                                    height={14}
                                                                />
                                                                <input
                                                                    onChange={this.onChangex}
                                                                    type="text"
                                                                    id="otpphone"
                                                                    name="otpphone"
                                                                    required="required"
                                                                    pattern="[0-9]*"
                                                                    maxLength="4"
                                                                    className="x-form-control form-control"
                                                                    placeholder="กรุณากรอก OTP 4 หลัก"
                                                                    autoFocus="autoFocus"
                                                                    autoComplete="on"
                                                                    inputMode="text"
                                                                />
                                                                <div id="checkotp" className="invalid-feedback ">
                                                                    <ul className="list-unstyled mb-0"><li>{stateopterror}</li></ul>
                                                                </div>
                                                            </div>
                                                            <div className="text-center">
                                                                <a href="#0" style={{ cursor: "pointer" }}
                                                                    onClick={(e) => {
                                                                        this.nextstep(e, 11)
                                                                    }} className="text-muted mt-3">
                                                                    ยกเลิก
                                                                </a>
                                                            </div>
                                                            <div className="text-center">

                                                                <button
                                                                    onClick={(e) => {
                                                                        this.nextstep(e, 5)
                                                                    }}
                                                                    type="submitx"
                                                                    className="btn   btn-primary mt-lg-3 mt-0"
                                                                    disabled=""
                                                                >
                                                                    ต่อไป
                                                                </button>
                                                            </div>
                                                            <input
                                                                type="hidden"
                                                                id="request_otp__token"
                                                                name="request_otp[_token]"
                                                                defaultValue="ds26nEjb1GacmW8racC7ScvGiCgTEnPl5xKWBzZyMWc"
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="-top " style={{ display: this.state.stateregis === 3 ? "" : "none" }}>
                                                    <h3 className="x-title-modal mx-auto text-center ">
                                                        กรอกเลขที่บัญชี
                                                    </h3>
                                                    <div className="-x-input-icon mb-3 text-center">
                                                        <div
                                                            data-animatable="fadeInModal"
                                                            className="-animatable-container animated fadeInModal"
                                                        >
                                                            <div className="text-center -img-container">
                                                                <div className="-title mt-3">กรุณาเลือกบัญชีธนาคารของท่าน</div>
                                                            </div>
                                                            <div className="x-step-register -v2">
                                                                <div className="px-0 m-auto -container-wrapper">
                                                                    <div className={"-step-box-outer" + (this.state.stateregis !== 3 ? "" : " step-active")}></div>
                                                                    <div className={"-step-box-outer" + (this.state.stateregis !== 3 ? "" : " step-active")}></div>
                                                                    <div className={"-step-box-outer" + (this.state.stateregis !== 3 ? "" : " step-active")}></div>
                                                                    <div className={"-step-box-outer" + (this.state.stateregis !== 3 ? "" : " step-active")}></div>
                                                                </div>
                                                            </div>
                                                            <div id="card-bank-info">
                                                                <div className="text-center">
                                                                    <div className="my-3 js-bank-select-container">
                                                                        <div className="x-bank-choices-type ">
                                                                            <div className="x-bank-choices-type">
                                                                                <div className="x-bank-choices-type">
                                                                                    <div className="-outer-wrapper" id="checkboxacc">
                                                                                        {[
                                                                                            { id: 5, img: "84c0f97b9a4a02bd519f6256da291d06" },
                                                                                            { id: 6, img: "75cf7484ae422a0d3897e82556cb04fd" },
                                                                                            { id: 7, img: "ffcda61156271aa5d354b4d052590a14" },
                                                                                            { id: 8, img: "4982427c6801f5e172ab1205a9166e2f" },
                                                                                            { id: 9, img: "62cdaab59a028355f43825a426c41b94" },
                                                                                            { id: 11, img: "6220cfdee8ca83b5533e6d5ac87b778b" },
                                                                                            { id: 12, img: "a3671c1989ca4935f046b184b98b28d1" },
                                                                                            { id: 14, img: "de6513eee5e2d90848de36a1be081ef5" },
                                                                                            { id: 15, img: "4320a4686226cba7c35cfdbbe25a0e95" },
                                                                                            { id: 16, img: "48e5e7cc029492341f34b7ce38926edd" },
                                                                                            { id: 17, img: "a68c3e5add8754e2c0e986c408c08c24" },
                                                                                            {
                                                                                                id: 99,
                                                                                                img: "https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/69f69205-db15-4dc5-e6cc-342f97a7de00/public",
                                                                                                isExternal: true,
                                                                                            },
                                                                                        ].map((bank) => (
                                                                                            <React.Fragment key={bank.id}>
                                                                                                <input
                                                                                                    type="radio"
                                                                                                    className="-input-radio"
                                                                                                    id={`bank-acc-${bank.id}692356943`}
                                                                                                    name="checkboxacc"
                                                                                                    value={bank.id}
                                                                                                    onChange={this.onChangeselect}
                                                                                                />
                                                                                                <label className="-label" htmlFor={`bank-acc-${bank.id}692356943`}>
                                                                                                    <img
                                                                                                        className="-logo"
                                                                                                        src={
                                                                                                            bank.isExternal
                                                                                                                ? bank.img
                                                                                                                : `/media/cache/strip/201910/${bank.img}.png`
                                                                                                        }
                                                                                                        alt=""
                                                                                                    />
                                                                                                    <i className="fas fa-check" />
                                                                                                </label>
                                                                                            </React.Fragment>
                                                                                        ))}
                                                                                    </div>
                                                                                </div>
                                                                            </div>

                                                                        </div>
                                                                    </div>
                                                                    <div className="js-bank-number-and-name-container position-relative">
                                                                        <div className="x-bank-info-validate-box -v2">
                                                                            <div className="-content-validate">
                                                                                โปรดตรวจสอบ ชื่อ และ เลขบัญชี !!
                                                                            </div>
                                                                            <div className="-detail-validate">
                                                                                หากไม่ถูกต้อง จะไม่สามารถแก้ไข หรือ ฝากถอนได้
                                                                            </div>
                                                                            <i className="fas fa-arrow-right" />
                                                                        </div>
                                                                        <div className="-x-input-icon mb-3 flex-column">
                                                                            <img
                                                                                className="-icon"
                                                                                alt="กระเป๋าเงิน ฝากถอน ออโต้"
                                                                                width={15}
                                                                                height={15}
                                                                                src="/build/web/igame-index-lobby-wm/img/ic-library-book-v2.png?v=5"
                                                                            />
                                                                            <input
                                                                                type="text"
                                                                                onChange={this.onChangex}
                                                                                id="accnumbertxt"
                                                                                name="accnumbertxt"
                                                                                required="required"
                                                                                pattern="[0-9]*"
                                                                                className="x-form-control form-control"
                                                                                placeholder="กรอกเลขบัญชี"
                                                                                autoFocus="autoFocus"
                                                                                inputMode="text"
                                                                            />
                                                                        </div>
                                                                        <div className="-x-input-icon mb-3 flex-column" style={{ display: this.state.trueaccount ? "none" : "" }}>
                                                                            <img
                                                                                className="-icon"
                                                                                alt="รองรับการเข้าใช้งานหลายผู้เล่น 24 ชั่วโมง"
                                                                                width={15}
                                                                                height={15}
                                                                                src="/build/web/igame-index-lobby-wm/img/ic-user-v2.png?v=5"
                                                                            />
                                                                            <input
                                                                                type="text"
                                                                                onChange={this.onChangex}
                                                                                id="fname"
                                                                                value={this.state.fname}
                                                                                name="fname"
                                                                                required="required"
                                                                                className="x-form-control form-control"
                                                                                placeholder="ชื่อบัญชี"
                                                                            />
                                                                        </div>
                                                                        <div className="-text-hint col-sm-10 m-auto d-block d-lg-none">
                                                                            กรอกข้อมูลให้ครบถ้วนและถูกต้องมิฉะนั้นท่านจะไม่สามารถถอนเงินได้
                                                                        </div>
                                                                    </div>
                                                                    <a
                                                                        href="#0"
                                                                        style={{ cursor: "pointer" }}
                                                                        onClick={(e) => {
                                                                            this.nextstep(e, 11)
                                                                        }} className="text-muted mt-3">
                                                                        ยกเลิก
                                                                    </a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <input
                                                            type="hidden"
                                                            id="customer_bank_account__token"
                                                            name="customer_bank_account[_token]"
                                                            defaultValue="EtuWE7npKiT8yTfHa4RNu7uFMEY1cTFVfBKaSda8kGc"
                                                        />

                                                    </div>
                                                    <div className="text-center">
                                                        <button
                                                            onClick={(e) => {
                                                                this.nextstep(e, 25)
                                                            }}
                                                            type="submitxa"
                                                            disabled={!this.state.disabledbuttonbankaccount}
                                                            className="btn   btn-primary mt-lg-3 mt-0"
                                                        >
                                                            ตรวจสอบ
                                                        </button>
                                                    </div>
                                                    <input
                                                        type="hidden"
                                                        id="request_otp__token"
                                                        name="request_otp[_token]"
                                                        defaultValue="ds26nEjb1GacmW8racC7ScvGiCgTEnPl5xKWBzZyMWc"
                                                    />
                                                </div>
                                                <div className="-top " style={{ display: this.state.stateregis === 2 ? "" : "none" }}>
                                                    <h3 className="x-title-modal mx-auto text-center ">
                                                        กรุณา Confirm Password
                                                    </h3>
                                                    <div className="-fake-inner-body">
                                                        <div className="x-step-register -v2">
                                                            <div className="px-0 m-auto -container-wrapper">
                                                                <div className={"-step-box-outer" + (this.state.stateregis !== 2 ? "" : " step-active")}></div>
                                                                <div className={"-step-box-outer" + (this.state.stateregis !== 2 ? "" : " step-active")}></div>
                                                                <div className={"-step-box-outer" + (this.state.stateregis !== 2 ? "" : " step-active")}></div>
                                                                <div className={"-step-box-outer" + (this.state.stateregis !== 1 ? "" : " step-active")}></div>
                                                            </div>
                                                        </div>
                                                        <div >
                                                            <div className="text-center">

                                                                <div className="-x-input-icon mb-3 text-center">
                                                                    <img
                                                                        src="/build/web/igame-index-lobby-wm/img/ic-input-lock.png"
                                                                        className="-icon"
                                                                        alt="SA Casino phone icon"
                                                                        width={10}
                                                                        height={14}
                                                                    />
                                                                    <input
                                                                        onChange={this.onChangex}
                                                                        type="password"
                                                                        id="password"
                                                                        name="password"
                                                                        required="required"
                                                                        className="x-form-control form-control"
                                                                        placeholder="กรุณารหัสผ่าน"
                                                                        autoFocus="autoFocus"
                                                                        autoComplete="on"
                                                                        inputMode="text"
                                                                    />
                                                                </div>
                                                                <div className="-x-input-icon mb-3 text-center">
                                                                    <img
                                                                        src="/build/web/igame-index-lobby-wm/img/ic-input-lock.png"
                                                                        className="-icon"
                                                                        alt="SA Casino phone icon"
                                                                        width={10}
                                                                        height={14}
                                                                    />
                                                                    <input
                                                                        onChange={this.onChangex}
                                                                        type="password"
                                                                        id="passwordcf"
                                                                        name="passwordcf"
                                                                        required="required"
                                                                        className="x-form-control form-control"
                                                                        placeholder="กรุณารหัสผ่าน"
                                                                        autoFocus="autoFocus"
                                                                        autoComplete="on"
                                                                        inputMode="text"
                                                                    />
                                                                    <div className="mt-3 -spacer  text-center" style={{ display: (this.state.errorstatus ? "" : "none") }}>
                                                                        <div className="x-danger-zone -v2  text-center">
                                                                            <span>{this.state.errortext}</span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <a href="#0" style={{ cursor: "pointer" }}
                                                                    onClick={(e) => {
                                                                        this.nextstep(e, 11)
                                                                    }}
                                                                    className="text-muted mt-3">
                                                                    ยกเลิก
                                                                </a>
                                                                <button
                                                                    onClick={(e) => {
                                                                        this.nextstep(e, 2)
                                                                    }}
                                                                    type="submitx"
                                                                    className="btn btn-primary mt-lg-3 mt-0 -submit"
                                                                    disabled=""
                                                                >
                                                                    ถัดไป
                                                                </button>
                                                            </div>
                                                            <input
                                                                type="hidden"
                                                                id="request_otp__token"
                                                                name="request_otp[_token]"
                                                                defaultValue="ds26nEjb1GacmW8racC7ScvGiCgTEnPl5xKWBzZyMWc"
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="-bottom ">
                                                    <div className="x-admin-contact text-center ">
                                                        <span className="x-text-with-link-component">
                                                            <label className="-text-message ">พบปัญหา</label>
                                                            <a
                                                                href={this.state.linelink}
                                                                className="-link-message "
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                <u>ติดต่อฝ่ายบริการลูกค้า</u>
                                                            </a>
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="x-modal modal " id="loginModal"
                    tabIndex={-1}
                    role="dialog"
                    aria-hidden="true"
                    data-loading-container=".js-modal-content"
                    data-ajax-modal-always-reload="true"

                >
                    <div
                        className="modal-dialog -modal-size modal-dialog-centered modal-dialog-scrollable -dialog-in-tab"
                        role="document"

                    >
                        <div className="modal-content -modal-content" >
                            <button
                                type="button"
                                className="close f-1 -in-tab"
                                data-dismiss="modal"
                                aria-label="Close"
                            >
                                <i className="fas fa-times" />
                            </button>
                            <div className="x-modal-account-security-tabs">
                                <button
                                    // style={{ textDecoration: "none" }}
                                    type="button"
                                    // href="/register"
                                    data-toggle="modal"
                                    className="-btn -register js-modal-account-security-tab-button "
                                    data-modal-target="#registerModal"
                                >
                                    สมัครสมาชิก
                                </button>
                                <button
                                    type="button"
                                    data-toggle="modal"
                                    className="-btn -login js-modal-account-security-tab-button -active"
                                    data-modal-target="#loginModal"
                                >
                                    เข้าสู่ระบบ
                                </button>
                            </div>
                            <div className="modal-body -modal-body">
                                <Login />
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    data-container=".social-share-modal-1"
                    tabIndex={-1}
                    id='socialShareMainModal'
                    role="dialog"
                    aria-hidden="true"
                    data-loading-container=".js-modal-content"
                    data-ajax-modal-always-reload="true"
                    className="modal x-modal -social-share-main-modal -v2 social-share-modal-1 "
                    aria-modal="true"
                >
                    <div
                        className="modal-dialog -modal-size -v2 modal-dialog-centered modal-dialog-scrollable         -modal-mobile -modal-medium -modal-social-share
    "
                        role="document"
                    >
                        <div className="modal-content -modal-content">
                            <button
                                type="button"
                                className="close f-1 "
                                data-dismiss="modal"
                                aria-label="Close"
                            >
                                <i className="fas fa-times" />
                            </button>
                            <div className="-social-share-header">
                                <div className="-img-container">
                                    <img
                                        className="-img img-fluid"
                                        src="https://aesexy.ai/media/cache/strip/202412/social-promotion/d494a10643f06dbc45b69d9fd64bb0c5.png"
                                        alt="แชร์ แลก ทรัพย์"
                                    />
                                </div>
                                <div className="-title-container">
                                    <h2 className="-title">แชร์ แลก ทรัพย์</h2>
                                    <h3 className="-sub-title">
                                        เงินทองกองอยู่ตรงหน้า จะรีบคว้า หรือ ปล่อยผ่าน#แชร์แลกทรัพย์
                                        #ขั้นตอนง่ายได้20 #ให้ทุกฝันอยู่ใกล้ขึ้น #ทำง่ายได้ทุกวัน
                                    </h3>
                                </div>
                            </div>
                            <div className="modal-body -modal-body">
                                <div className="d-flex flex-column">
                                    <div id="form-social-share-container">
                                        <div className="-social-share-form">
                                            <div>
                                                <p>
                                                    1. เข้าไปที่เพจ :{" "}
                                                    <b>
                                                        <a
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                        >
                                                            Event BET
                                                        </a>
                                                    </b>
                                                    <a
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        {" "}
                                                    </a>
                                                    และแชร์โพสต์ที่ปักหมุด
                                                </p>
                                                <p>
                                                    2. คัดลอกแคปชั่น และแฮชแท็กสำหรับใส่ในโพสต์ แต่งคอมเมนต์
                                                    พร้อมวางแคปชั่นและแฮชแท็กลงไป
                                                </p>
                                                <p>
                                                    * หน้าเฟซบุ๊กเปิดสาธารณะ 1 โพสต์ , แชร์ลงกลุ่ม 2 กลุ่ม และ
                                                    กดไลก์เพจ :{" "}
                                                    <b>
                                                        <a
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                        >
                                                            Event BET
                                                        </a>
                                                    </b>
                                                    <br />
                                                    ** พร้อมคัดลอกลิงก์ของแต่ละโพสต์
                                                    เพื่อนำมาแนบไฟล์ส่งเป็นหลักฐาน (โพสต์ละ 1 ลิงก์)
                                                    <br />
                                                    3. เมื่อแชร์ครบตามเงื่อนไขแล้ว กด "แนบไฟล์เพื่อรับสิทธิ์"
                                                    เพื่อรับโบนัส
                                                    <br />
                                                    4. แอดมินจะตรวจสอบโพสต์จากลิงก์ในวันถัดไป
                                                    และเครดิตจะเข้าหลังจากแอดมินตรวจเสร็จทันที
                                                    แต่ถ้าไม่พบหลักฐานในลิงก์ถือว่าสละสิทธิ์ ❌<br />*
                                                    ต้องเป็นบัญชีจริงที่มีการเคลื่อนไหว และเปิดเป็นโพสต์สาธารณะ
                                                    เพื่อการตรวจสอบ
                                                    <br />* บัญชีเฟซบุ๊กที่ทำแชร์แลกทรัพย์ ต้องมีเพื่อนมากกว่า 300
                                                    คนขึ้นไป
                                                    <br />*
                                                    กลุ่มที่ทำการแชร์ต้องเป็นกลุ่มสาธารณะและมีสมาชิกมากกว่า 1,000
                                                    คนขึ้นไป
                                                    <br />* จำกัดสิทธิ์ 1 บุคคล 1 ครั้งต่อวัน
                                                    <br />
                                                </p>
                                                <p>
                                                    **สามารถถอนเครดิตแชร์แลกทรัพย์ได้ ต่อเมื่อฝากครบ 500 บาทขึ้นไป
                                                    ภายใน 14 วัน**
                                                </p>
                                            </div>
                                            * สมาชิกต้อง<u className="-text-highlight">เปิดเป็นโพสสาธารณะ</u>
                                            เพื่อการตรวจสอบ มิเช่นนั้นจะถือว่าสละสิทธิ์
                                            <hr className="x-hr-border-primary" />
                                            <form
                                                noValidate=""
                                                name="social_share_submit"
                                                method="post"
                                                data-loading-container=".modal-body"
                                                data-container=".-social-share-main-modal"
                                            >
                                                <div className="-social-share-detail-container">
                                                    <div className="row flex-wrap -text-step-container">
                                                        <div className="col-sm-6">
                                                            <div className="-text-step-container-wrapper">
                                                                <div className="-number-container">1</div>
                                                                <div className="-text-step-detail">
                                                                    <div>
                                                                        คัดลอก แคปชั่น แฮชแท็ก สำหรับใส่ในโพส คอมเม้นซะหน่อย
                                                                        พร้อมวางแคปชั่นแฮชแท็กลงไป
                                                                    </div>
                                                                    <a
                                                                        href="javascript:void(0);"
                                                                        className="btn btn-primary mt-2 js-copy-to-clipboard -social-share-btn"
                                                                        data-container="form-social-share-container"
                                                                        data-message="<i class='fas fa-check'></i> คัดลอกแล้ว"
                                                                        data-copy-me="🌎 AE Sexy อันดับหนึ่งที่คุณต้องสัมผัส 
🔥 สมาชิกใหม่ 100 รับ 150
🔥 สมาชิกใหม่ 300 รับ 500
🔥 สมาชิกใหม่รับโบนัส 50% สูงสุด 1,000
🔥 โปรร้อนแรง ฝาก 1000 ฟรี 100 ไม่ติดเงื่อนไข
🔥 เล่นได้ให้เพิ่ม เล่นเสียคืนให้ 5% ทุกวันเสาร์ รับได้ตลอดชีพ
🎁 ฝาก - ถอน 3 วิ. ด้วยระบบ AI ที่ใช้ได้จริงเจ้าเดียวในไทย

#แชร์แลกทรัพย์ #รับได้ทุกวัน #ทำได้ทุกคน #ทำง่ายไม่กี่ขั้นตอน #เว็บดีโปรแรง #อันดับหนึ่ง #AEsexy #ฝากถอนไวสุด
#AEที่ดีที่สุด"
                                                                        data-html="true"
                                                                    >
                                                                        <i className="fas fa-copy" /> คัดลอก
                                                                    </a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-sm-6 mt-sm-0 mt-3">
                                                            <div className="-text-step-container-wrapper">
                                                                <div className="-number-container">2</div>
                                                                <div className="-text-step-detail">
                                                                    <div>
                                                                        กด "แชร์เลย" จะมีสิ่งดีๆ เพื่อแชร์ไปยัง facebook
                                                                    </div>
                                                                    <a
                                                                        target="_blank"
                                                                        className="btn btn-primary mt-2 -social-share-btn"
                                                                    >
                                                                        <div>
                                                                            <i className="fas fa-share mr-2" />
                                                                            <span>แชร์เลย</span>
                                                                        </div>
                                                                    </a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-sm-6 mt-3">
                                                            <div className="-text-step-container-wrapper">
                                                                <div className="-number-container">3</div>
                                                                <div className="-text-step-detail">
                                                                    <div>
                                                                        แนบหลักฐาน เพื่อรับสิทธิ์
                                                                        รับโบนัสและรอยืนยันไม่เกินอดใจ
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row justify-content-center">
                                                    <div className="-form-container col-12 col-sm-10">
                                                        <div className="-x-input-icon mt-3">
                                                            <i className="fas fa-link -icon" />
                                                            <input
                                                                type="text"
                                                                id="social_share_submit_links_0"
                                                                name="social_share_submit[links][0]"
                                                                required="required"
                                                                inputMode="url"
                                                                className="x-form-control js-ss-input-link form-control"
                                                                placeholder="ลิงค์หลักฐาน 1"
                                                            />
                                                        </div>
                                                        <div className="-x-input-icon mt-3">
                                                            <i className="fas fa-link -icon" />
                                                            <input
                                                                type="text"
                                                                id="social_share_submit_links_1"
                                                                name="social_share_submit[links][1]"
                                                                required="required"
                                                                inputMode="url"
                                                                className="x-form-control js-ss-input-link form-control"
                                                                placeholder="ลิงค์หลักฐาน 2"
                                                            />
                                                        </div>
                                                        <div className="-x-input-icon mt-3">
                                                            <i className="fas fa-link -icon" />
                                                            <input
                                                                type="text"
                                                                id="social_share_submit_links_2"
                                                                name="social_share_submit[links][2]"
                                                                required="required"
                                                                inputMode="url"
                                                                className="x-form-control js-ss-input-link form-control"
                                                                placeholder="ลิงค์หลักฐาน 3"
                                                            />
                                                        </div>
                                                        <div className="text-center mt-3">
                                                            <button
                                                                type="submit"
                                                                className="btn btn-primary -submit js-promotion-submit-btn"
                                                                disabled=""
                                                            >
                                                                <i className="fas fa-upload mr-2" />
                                                                <span>ส่งหลักฐาน</span>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <input
                                                    type="hidden"
                                                    id="social_share_submit__token"
                                                    name="social_share_submit[_token]"
                                                    defaultValue="e164UU3TPIKYKptFJ0dBecKjZFh2rcTlZSXore0g0Y4"
                                                />
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </>
        );
    }
}

export default Main;
